// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

p#contactsection {
  color: #000;
  font-family: "Playfair Display" !important;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

element.style {
  font-family: sectionTitleFont;
  color: white;
  padding-top: 10px;
  padding-bottom: 10px;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}

.title-video-container.css-1qokjtz {
  font-family: sectionTitleFont;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
  font-size: 62px;
  font-style: normal;
  font-weight: 500;
  padding-bottom: 83px;
  z-index: 9999 !important;
}

.SubTitle-video-container.css-1lhfysi {
  padding-top: 92px;
  color: var(--White, #fff);
  font-family: "Helvetica Neue", sans-serif;
  font-size: 19px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  top: 53%;
  z-index: 9999 !important;
}

.broucher-btn {
  margin-top: 2rem !important;
  border: 1px solid var(--White, #fff) !important;
  background-color: transparent !important;
  color: white !important;
  padding: 16px 32px !important;
  color: var(--White, #fff);
  font-family: "Helvetica Neue", sans-serif !important;
  font-size: 18px !important;
  font-style: normal;
  font-weight: 400 !important;
  line-height: normal !important;
  text-transform: uppercase !important;
  top: 73% !important;
  z-index: 9999 !important;
}

p {
  color: #000;
  font-family: "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
}

.broucher-btn:hover {
  background-color: white !important;
  color: #000 !important;
  border: none !important;
}

.main-menu button:hover {
  background-color: transparent;
}

.main-menu button {
  align-items: center !important;
  color: var(--Black, #000);
  font-family: "Helvetica Neue", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
}

.main-menu-container {
  /* background: #cbc5b3; */
  /* box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.08); */
}

/* Styles for screens smaller than 600px (typically mobile devices) */
@media only screen and (max-width: 900px) {
  ul.footer-menu {
    display: none !important;
  }
  .logo.css-6w6kfw {
    z-index: 5 !important;
  }
  .contact-row-ipad{
    width: 100% !important;
    margin-left: 0 !important;
  }

  .css-o4bg9w-MuiGrid-root {
    flex-basis: 100.666667% !important;
    flex-grow: 0;
    max-width: 100.666667% !important;
  }
  .about-grid-mobile {
    padding-left: 1px !important;
  }

  .css-1ild15j-MuiGrid-root {
    box-sizing: border-box;
    display: flex;
    -webkit-box-flex-wrap: wrap;
    flex-wrap: wrap;
    width: 100%;
    flex-direction: row;
    justify-content: center !important;
    align-items: center;
    padding-top: 32px !important;
    padding-bottom: 32px !important;
    align-content: center !important;
  }

  .MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-1.MuiGrid-direction-xs-column.Content-bullets.css-h7pwju-MuiGrid-root {
    padding-top: 0px !important;
  }

  .css-qi3ouq-MuiGrid-root {
    padding-top: 25px !important;
  }

  .discription-pera {
    text-align: justify !important;
  }

  .discription-pera-main {
    text-align: justify !important;
  }

  .estate {
    padding: 0px !important;
    color: black !important;
    opacity: 1 !important;
    text-align: left;
    padding-left: 50px;
    font-weight: 600 !important;
    padding-left: 0rem !important;
  }

  img.rectangle-10 {
    max-width: 300px !important;
  }

  .features-container {
    padding-right: 20px;
    padding: 30px 0px 0px 0px !important;
  }

  .location-options {
    display: flex !important;
    flex-wrap: wrap !important;
    flex-direction: column !important;
    align-content: flex-start !important;
    justify-content: center !important;
  }
  .MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-1.MuiGrid-direction-xs-column.Content-bullets.css-h7pwju-MuiGrid-root {
    padding-top: 122px;
  }

  img.partners-logo {
    width: 150px;
    margin-bottom: 25px !important;
  }

  div#root {
    overflow: hidden !important;
  }
  .about-grid-mobile {
    margin-top: -18rem !important;
  }
  img.logo-devloper-ah {
    width: 100% !important;
    margin-top: 0rem !important;
    justify-content: center !important;
    flex-wrap: wrap !important;
    display: inline-flex !important;
    align-content: center !important;
    margin-left: 0rem !important;
  }

  .discription-pera {
    font-family: "Helvetica Neue", sans-serif !important;
    font-size: 20px !important;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    padding-bottom: 20px !important;
    opacity: 0.6;
    color: black;
    margin-bottom: 40px;
  }
  .contact-text-container-2 {
    display: block;
    width: 410px;
    margin-left: 20px !important;
  }

  .card-section {
    width: 80% !important;
    margin-left: 0px !important;
  }

  .box-clusters {
    text-align: center !important;
    border-radius: 8px !important;
    border: 1px solid rgb(203, 197, 179) !important;
    height: 100px !important;
    width: 270px !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
      "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
      "Helvetica Neue", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden !important;
  }

  .last-box {
    margin-top: 4rem !important;
  }

  .bg-image-col {
    max-width: 106.333333% !important;
    padding-top: 496px !important;
    margin: auto !important;
    width: 100% !important;
    /* height: 100% !important; */
    margin-top: 2rem !important;
    margin-left: 0rem !important;
  }

  .css-zqi6k4-MuiGrid-root {
    box-sizing: border-box;
    margin: 0;
    flex-direction: row;
    flex-basis: 83.333333%;
    flex-grow: 0;
    max-width: 100.333333% !important;
  }
  .box-2 {
    /* height: 150px !important; */
    display: flex !important;
    flex-direction: column !important;
    justify-content: flex-start !important;
    margin-top: 1rem;
    height: 113px !important;
    margin-top: 1rem;
    width: 278px !important;
    padding-left: 20px !important;
    text-align: left !important;
  }

  img.gallery-control-btn {
    width: 30px !important;
  }
  .gallery-image {
    width: 100% !important;
    height: 426px !important;
    display: block !important;
    margin: 0 auto !important;
    object-fit: cover !important;
  }
  .estate {
    padding: 0px !important;
    color: black !important;
    opacity: 1 !important;
    text-align: left;
    padding-left: 0px !important;
    font-weight: 600 !important;
    text-align: center !important;
  }

  .box-1 {
    display: flex !important;
    flex-direction: column !important;
    justify-content: flex-start !important;
    margin-top: 1rem;
    height: 100px !important;
    margin-top: 1rem;

    width: 286px !important;
    text-align: left !important;
  }

  .grid-mobile-aboutus {
    display: flex !important;
    flex-direction: column !important;
    justify-content: space-around !important;
    flex-wrap: nowrap !important;
    align-items: center;
  }
  .partners-container {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    padding-bottom: 57px;
    flex-direction: column !important;
    display: block !important;
    padding: 0px !important;
  }

  .estate {
    padding: 0px !important;
    color: black !important;
    opacity: 1 !important;
    text-align: center !important;
    padding-left: 0px !important;
    font-weight: 600 !important;
  }

  ul.clustor-list li {
    display: flex !important;
    align-content: center !important;
    flex-wrap: nowrap !important;
    flex-direction: row !important;
    align-items: center !important;
    padding-bottom: 26px !important;
  }
  .title-video-container.css-1qokjtz {
    font-family: sectionTitleFont;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    font-size: 41px !important;
    font-style: normal;
    font-weight: 500;
    padding-bottom: 70px;
    z-index: 9999 !important;
  }

  .css-6w6kfw {
    position: absolute;
    top: 10% !important;
    /* left: 50% !important; */
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    font-weight: bold;
  }

  .request-btn {
    border: 1px solid #fff !important;
    background-color: transparent !important;
    color: white !important;
    padding: 16px 32px !important;
    color: var(--White, #fff);
    font-family: "Helvetica Neue" !important;
    font-size: 18px !important;
    font-style: normal;
    font-weight: 400 !important;
    line-height: normal !important;
    text-transform: uppercase !important;
    display: none !important;
    z-index: 9999 !important;
  }

  .partners-container {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    padding-bottom: 57px;
    flex-direction: column !important;
  }

  .aminities-container {
    display: flex !important;
    align-items: flex-start !important;
    justify-content: space-around !important;
    align-content: space-around;
    padding-bottom: 30px !important;
    margin-left: 0px !important;
    flex-direction: column !important;
  }

  .card-section {
    border-radius: 16px;
    background: #313b2f;
    box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32);
    color: white;
    /* margin: 7px 14px; */
    /* text-align: left !important; */
    height: 538px;
    width: 60%;
  }

  .SubTitle-video-container.css-1lhfysi {
    padding-top: 92px;
    color: var(--White, #fff);
    font-family: "Helvetica Neue", sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    top: 57%;
    z-index: 9999 !important;
  }

  div#root body {
    overflow-x: hidden;
  }

  .card-features {
    padding-bottom: 36px;
  }

  .partners-container {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-bottom: 57px;
    flex-direction: column !important;
  }

  p.partners-para {
    padding-left: 0px;
    text-align: center;
  }

  img.partners-logo {
    width: 171px;
  }
}

@media only screen and (max-width: 599px) {
  /* Your CSS styles for mobile devices */
  .features-container {
    width: 100% !important;
    height: auto !important;
    background-color: rgb(203, 197, 179) !important;
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    padding: 40px 0px 0px 10px !important;
    margin-top: 30px !important;
    margin-bottom: 30px !important;
    border-radius: 8px !important;
    flex-direction: column !important;
    flex-wrap: nowrap !important;
    align-content: flex-start !important;
  }
}

/* Styles for screens between 600px and 959px (typically larger smartphones and smaller tablets) */
/* web screen media start */
@media only screen and (min-width: 1500px) and (max-width: 1600px) {
  /*.MuiGrid-container {
      padding-left: 50px !important;
      padding-right: 50px !important;
  }*/
  footer .MuiGrid-root.MuiGrid-item.css-13i4rnv-MuiGrid-root {
    width: 300px;
  }
  .estate {
    padding: 0px !important;
    color: black !important;
    opacity: 1 !important;
    text-align: left;
    padding-left: 50px;
    font-weight: 600 !important;
    padding-left: 2rem !important;
  }

  .card-section {
    border-radius: 16px;
    background: #313b2f;
    box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32);
    color: white;
    /* margin: 7px 14px; */
    padding: 32px !important;
    text-align: left !important;
    height: 538px;
  }
}

@media only screen and (min-width: 1440px) and (max-width: 1440px) {
  .features-container.aos-init.aos-animate {
    width: 86vw !important;
    padding: 0px 27px !important;
  }

  .about {
    width: 100% !important;
}

  .estate {
    padding: 0px !important;
    color: black !important;
    opacity: 1 !important;
    text-align: left;
    padding-left: 50px;
    font-weight: 600 !important;
    padding-left: 2rem !important;
  }
  footer .MuiGrid-root.MuiGrid-item.css-13i4rnv-MuiGrid-root {
    width: 300px;
  }
  .box-2 {
    /* height: 150px !important; */
    display: flex !important;
    flex-direction: column !important;
    justify-content: flex-start;
    margin-top: 1rem;
    height: 100px !important;
    margin-top: 1rem;
    width: 390px !important;
  }

  .box-1 {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 100px !important;
    margin-top: 1rem;
    width: 173px !important;
    align-items: flex-start !important;
  }

  .card-section {
    border-radius: 16px;
    background: #313b2f;
    box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32);
    color: white;
    /* margin: 7px 14px; */
    padding: 32px !important;
    text-align: left !important;
    height: 538px;
  }
}

@media only screen and (min-width: 1200px) {
  .css-6w6kfw {
    position: absolute;
    top: 10% !important;
    left: 10% !important;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    font-weight: bold;
    z-index: 10000;
  }

  .request-btn-m {
    background-color: transparent !important;
    top: 14% !important;
    right: 65px;
    box-shadow: none !important;
  }
}

@media only screen and (min-width: 1920px) and (max-width: 1920px) {
  img.rectangle-10 {
    max-width: 90% !important;
  }

  footer .MuiGrid-root.MuiGrid-item.css-13i4rnv-MuiGrid-root {
    width: 300px;
  }
  .location-options {
    margin-top: 130px !important;
  }
  .estate {
    padding: 0px !important;
    color: black !important;
    opacity: 1 !important;
    text-align: left;
    padding-left: 50px;
    font-weight: 600 !important;
    margin-left: 2rem !important;
  }

  .box-1 {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 113px !important;
    margin-top: 1rem;
    width: 230px !important;
    align-items: flex-start !important;
  }

  .card-section {
    border-radius: 16px;
    background: #313b2f;
    box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32);
    color: white;
    /* margin: 7px 14px; */
    padding: 73px !important;
    text-align: left !important;
    height: 538px;
  }

  .box-2 {
    /* height: 150px !important; */
    display: flex !important;
    flex-direction: column !important;
    justify-content: flex-start;
    margin-top: 1rem;
    height: 113px !important;
    margin-top: 1rem;
    width: 506px !important;
    align-items: flex-start !important;
  }
}
@media only screen and (min-width: 1600px) and (max-width: 1600px) {
  .estate {
    padding: 0px !important;
    color: black !important;
    opacity: 1 !important;
    text-align: left;
    padding-left: 50px;
    font-weight: 600 !important;
    margin-left: 2rem !important;
  }

  .box-1 {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 113px !important;
    margin-top: 1rem;
    width: 197px !important;
    align-items: flex-start !important;
  }

  .card-section {
    border-radius: 16px;
    background: #313b2f;
    box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32);
    color: white;
    /* margin: 7px 14px; */
    padding: 32px !important;
    text-align: left !important;
    height: 538px;
  }
  .box-2 {
    /* height: 150px !important; */
    display: flex !important;
    flex-direction: column !important;
    justify-content: flex-start;
    margin-top: 1rem;
    height: 113px !important;
    margin-top: 1rem;
    width: 430px !important;
    align-items: flex-start !important;
  }
  .about-sub-box {
    font-size: 15px !important;
  }
  .location-options {
    margin-top: 130px !important;
  }
}
@media only screen and (min-width: 1366px) and (max-width: 1366px) {
  .location-options {
    margin-top: 130px !important;
  }
  footer .MuiGrid-root.MuiGrid-item.css-13i4rnv-MuiGrid-root {
    width: 300px;
  }
  .estate {
    padding: 0px !important;
    color: black !important;
    opacity: 1 !important;
    text-align: left;
    padding-left: 50px;
    font-weight: 600 !important;
    margin-left: 2rem !important;
  }

  .estate {
    padding: 0px !important;
    color: black !important;
    opacity: 1 !important;
    text-align: left;
    padding-left: 50px;
    font-weight: 600 !important;
    padding-left: 2rem !important;
  }

  .main-menu button {
    align-items: center !important;
    color: var(--Black, #000);
    font-family: "Helvetica Neue", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
    padding-right: 0rem !important;
  }

  .box-1 {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 113px !important;
    margin-top: 1rem;
    width: 160px !important;
  }

  .box-2 {
    /* height: 150px !important; */
    display: flex !important;
    flex-direction: column !important;
    justify-content: flex-start;
    margin-top: 1rem;
    height: 113px !important;
    margin-top: 1rem;
    width: 342px !important;
  }
}
/*  */

@media only screen and (min-width: 600px) and (max-width: 959px) {
  /* Your CSS styles for larger smartphones and smaller tablets */

  .title-video-container.css-1qokjtz {
    font-family: sectionTitleFont;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    font-size: 41px;
    font-style: normal;
    font-weight: 500;
    padding-bottom: 83px;
    z-index: 9999 !important;
  }
}

/* Styles for screens between 960px and 1279px (typically larger tablets and small laptops) */

@media only screen and (min-width: 250px) and (max-width: 390px) {
  .boxs-border-cards {
    display: flex;
    gap: 44px;
    flex-direction: column;
    width: 260px !important;
    align-items: flex-start;
    padding-left: 29px;
    max-width: 100%;
  }

  /* Your CSS styles for larger tablets and small laptops */
}

/* Styles for screens larger than 1280px (typically desktops and laptops) */

@media only screen and (min-width: 1280px) {
  /* Your CSS styles for desktops and laptops */
}

/* web css start */

.title {
  color: #313b2f;
  font-family: "Playfair Display", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
}

/* end  */

/* mustfa css start */
.about {
  font-family: "Playfair Display";
}
.about-body {
  font-family: "Helvetica Neue";
  opacity: 60%;
  font-size: 24px;
  font-weight: 300;
  line-height: 29px;
}

/* body font css  */

.css-iaplqc-MuiTypography-root {
  font-family: "Playfair Display", sans-serif !important;
}

.partners-container {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding-bottom: 47px;
  margin-left: 2rem;
}

p.partners-para {
  padding-left: 47px;
  color: #000;
  font-family: "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
}

img.rectangle-10 {
  /* max-width: 90% !important; */
}

.location-options {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
}

.Content-bullets {
  padding-left: 10px !important;
  color: var(--Black, #000);
  font-family: "Helvetica Neue", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
}

.location-sub {
  color: var(--Black, #000);
  font-family: "Playfair Display" !important;
  font-size: 32px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: normal !important;
  text-transform: uppercase !important;
  padding-bottom: 10px !important;
}

.location-head {
  color: var(--Black, #000) !important;
  font-family: "Playfair Display" !important;
  font-size: 20px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: normal !important;
}

.main-menu button {
  align-items: center !important;
  color: var(--Black, #000);
  font-family: "Helvetica Neue", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
  padding-right: 0rem;
}

.css-gjpydu-MuiGrid-root {
  box-sizing: border-box;
  display: flex;
  -webkit-box-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
  flex-direction: row;
  margin-top: -16px;
  width: calc(100% + 20px);
  margin-left: 9px;
  max-width: 1536px;
  justify-content: flex-start;
}

img.rectangle-8 {
  width: 100%;
}

.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.main-menu.css-gjpydu-MuiGrid-root {
  justify-content: flex-start;
  margin-left: 6px;
}

img.icon-clustor {
  padding-right: 20px;
}

ul.clustor-list li {
  display: flex;
  align-content: center;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  padding-bottom: 26px;
}

.box-2 {
  /* height: 150px !important; */
  display: flex !important;
  flex-direction: column !important;
  justify-content: flex-start;
  margin-top: 1rem;
}

.box-1 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  /* height: 150px !important; */
  margin-top: 1rem;
}

.about {
  color: var(--Black, #000);
  font-family: "Playfair Display";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-bottom: 1px;
  padding-top: 16px;
}

.about-grid {
  display: flex;
  justify-content: flex-start;
  align-content: center;
  flex-wrap: wrap;
  flex-direction: row;
}

p#aboutsection {
  color: var(--Secondary, #cbc5b3);
  font-family: "Playfair Display";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.location-head {
  color: var(--Black, #000) !important;
  font-family: "Playfair Display" !important;
  font-size: 32px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: normal !important;
  padding-bottom: 10px !important;
  padding-top: 20px !important;
}

.discription-pera {
  font-family: "Helvetica Neue", sans-serif !important;
  font-size: 20px !important;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  padding-bottom: 20px !important;
  opacity: 0.6;
  color: black;
}

.about {
  color: var(--Black, #000);
  font-family: "Playfair Display";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  opacity: 0.6;
  padding-bottom: 20px;
}

.about-sub-box {
  color: var(--Black, #000);
  font-family: "Helvetica Neue";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.discription-pera-main {
  /*font-family: "Helvetica Neue" !important;*/
  font-size: 20px !important;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  padding-bottom: 20px !important;
  opacity: 0.6;
  /* color: black; */
  color: navajowhite;
}

.clustor-box-title {
  color: var(--White, #fff);
  font-family: "Playfair Display" !important;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 400 !important;
  line-height: normal;
  text-transform: uppercase !important;
  opacity: 0.6;
  padding-bottom: 21px !important;
  text-align: left !important;
}

.clustor-box-sub {
  color: var(--White, #fff);
  font-family: "Helvetica Neue", sans-serif !important;
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: normal !important;
  text-align: left !important;
}

.estate {
  padding: 0px !important;
  color: black !important;
  opacity: 1 !important;
  text-align: left;
  padding-left: 50px;
  font-weight: 600 !important;
}
.aminites {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

.contact-icons {
  font-family: "Helvetica Neue", sans-serif !important;
  font-size: 20px !important;
  margin-bottom: 40px !important;
}
.icon-socails {
  font-size: 30px !important;
  width: 2em !important;
}
.contact-icons span {
  position: relative;
  top: -8px;
  opacity: 0.8;
}

.contact-text-container-2 {
  padding: 30px 60px 60px 0 !important;
}

.request-btn {
  border: 1px solid #fff !important;
  background-color: transparent !important;
  color: white !important;
  padding: 16px 32px !important;
  color: var(--White, #fff);
  font-family: "Helvetica Neue", sans-serif !important;
  font-size: 18px !important;
  font-style: normal;
  font-weight: 400 !important;
  line-height: normal !important;
  text-transform: uppercase !important;
  z-index: 9999 !important;
}

.request-btn:hover {
  background-color: white !important;
  color: #000 !important;
}

.features-container {
  padding-right: 20px;
  padding: 0px 23px;
}

/* end  */

/* end */

/* mustfa css start here */

@media screen and (max-width: 426px) {
  /* Your CSS styles for desktops and laptops */
  .copyright {
    padding-left: 60px !important;
    padding-bottom: 10px;
  }
  .terms {
    padding-left: 80px !important;
  }
  .partners-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  /* .partners-des-1{
    padding-top: 160px;
  }
  .parners-logo{
   margin: 10px;
  } */
  .form-info-text {
    font-size: 20px;
    margin-bottom: 40px;
  }
  .customGridPadding {
    flex-basis: none !important;
    max-width: 100% !important;
  }
  .contact-text-container-2 {
    display: block;
    width: 400px;
  }
}

.header-button {
  margin-left: 180px !important;
}
.header-logo {
  margin-right: 200px;
}
/* end  */

/* end */

/* contact form */
.input-field {
  width: 467px !important;
}
.customGridHeight {
  padding-top: 10px;
  padding-bottom: 10px;
  /* Adjust this value to your desired height */
}

/* input css contact css start here */

.css-md26zr-MuiInputBase-root-MuiOutlinedInput-root.Mui-focused
  .MuiOutlinedInput-notchedOutline {
  border-color: #ffffff !important;
  border-width: 2px !important;
}

.css-14lo706 > span {
  padding-left: 5px;
  padding-right: 5px;
  display: inline-block;
  opacity: 0;
  font-size: 20px !important;
  visibility: visible;
}

.contact-icons {
  display: flex;
  align-content: flex-start;
}

svg.MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium.icon-socails.css-4guzyp-MuiSvgIcon-root {
  width: 40px;
  height: 40px;
  margin-top: -11px;
}
.css-1410706 > span {
  font-size: 20px !important;
}

.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input:focus {
  border: 0;
}
footer {
  padding: 0px 40px;
}
.css-w2rlnz-MuiTypography-root {
  float: left;
}

.video-container {
  z-index: 9999 !important;
}
/* end */

@media (max-width: 1199px) {
  .css-fv3sos button {
    z-index: 5 !important;
  }
}

@media (min-width: 1200px) {
  .box-1 {
    border: none !important;
  }

  .box-2 {
    border: none !important;
  }

  .about {
    color: var(--Black, #000);
    font-family: "Playfair Display";
    font-size: 15px !important;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    opacity: 0.6;
    padding-bottom: 20px;
  }

  .about-sub-box {
    color: var(--Black, #000);
    font-family: "Helvetica Neue";
    font-size: 13px !important;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
}

/* breakpoint css start here */
@media only screen and (min-width: 1280px) and (max-width: 1426px) {
  .box-1 {
    width: 150px !important;
  }

  .box-2 {
    width: 330px !important;
  }

  .main-menu button {
    align-items: center !important;
    color: var(--Black, #000);
    font-family: "Helvetica Neue", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
    padding-right: 0.6rem !important;
  }

  .box-2 {
    width: 375px;
  }
}

/* CSS for Desktop/Laptop (Larger than 1200px wide) */
@media (max-width: 1200px) {
  /* Add your CSS styles for desktop/laptop landscape here */

  .request-btn-m {
    background-color: transparent !important;
    top: 10% !important;
    right: 0px !important;
    box-shadow: none !important;
  }

  .box-clusters {
    height: 94px !important;
  }
}

@media (min-width: 1200px) and (orientation: portrait) {
  /* Add your CSS styles for desktop/laptop portrait here */

  .box-clusters {
    height: 94px !important;
  }
}

/* CSS for Tablet Landscape (Breakpoint range: 1024px to 1199px) */
@media (min-width: 1024px) and (max-width: 1199px) and (orientation: landscape) {
  .main-menu button {
    align-items: center !important;
    color: var(--Black, #000);
    font-family: "Helvetica Neue", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
    padding-right: 0rem;
  }
  /* Add your CSS styles for tablet landscape here */
}

@media (min-width: 1024px) and (max-width: 1199px) and (orientation: portrait) {
  .main-menu button {
    align-items: center !important;
    color: var(--Black, #000);
    font-family: "Helvetica Neue", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
    padding-right: 0rem;
  }

  .box-1 {
    width: 128px !important;
  }

  .box-2 {
    /* height: 150px !important; */

    width: 297px !important;
  }

  /* Add your CSS styles for tablet portrait here */
}
@media only screen and (min-width: 800px) and (max-width: 899px) {
  .about-grid-mobile {
    margin-top: 0rem !important;
  }

  .about-grid {
    display: flex;
    justify-content: center;
    align-content: flex-start;
    flex-wrap: wrap;
    flex-direction: column !important;
    align-items: flex-start;
  }
  .box-1 {
    width: 655px !important;
  }

  .box-2 {
    width: 643px !important;
  }
  .css-mhc70k-MuiGrid-root {
    flex-direction: column !important;

    /* margin-left: -16px; */
  }

  .card-section {
    width: 100% !important;
    margin-left: 0px !important;
  }
  .css-1osj8n2-MuiGrid-root {
    flex-basis: 100% !important;
    flex-grow: 0;
    max-width: 80% !important;
  }

  .css-etaaxy-MuiGrid-root {
    flex-basis: 100% !important;
    flex-grow: 0;
    max-width: 100% !important;
  }

  .box-clusters {
    text-align: center !important;
    border-radius: 8px !important;
    border: 1px solid rgb(203, 197, 179) !important;
    height: 100px !important;
    width: 637px !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  img.logo-devloper-ah {
    width: 100% !important;
    margin-top: 10rem !important;
    justify-content: center;
    flex-wrap: wrap !important;
    display: inline-flex !important;
    align-content: space-between;
    margin-left: 0rem !important;
    flex-direction: column;
  }
  .css-11lxi55-MuiGrid-root {
    flex-basis: 41.666667%;
    flex-grow: 0;
    max-width: 83.666667% !important;
  }
  .css-wn4jt8-MuiGrid-root {
    flex-direction: column !important;
  }
  .css-bwvw8j-MuiGrid-root {
    flex-basis: 100.666667% !important;

    max-width: 100.666667% !important;
  }

  .contact-row-ipad {
    flex-direction: row !important;
  }
}

@media only screen and (min-width: 360px) and (max-width: 400px) {
  .about-grid-mobile {
    margin-top: -30rem !important;
  }
}

@media only screen and (min-width: 600px) and (max-width: 791px) {
  .about-grid-mobile {
    margin-top: 0rem !important;
  }
}

/* CSS for Tablet Portrait (Breakpoint range: 768px to 1023px) */
@media (min-width: 768px) and (max-width: 768px) {
  .about-grid-mobile {
    margin-top: 0rem !important;
  }
  .about-grid {
    display: flex !important;
    justify-content: center !important;
    align-content: flex-start !important;
    flex-wrap: wrap !important;
    flex-direction: column !important;
    align-items: flex-start !important;
  }

  .box-2 {
    border: none !important;
    padding-left: 14px !important;
  }

  .box-1 {
    border: none !important;
  }
  .location-options {
    flex-basis: 100.333333% !important;
    max-width: 100.333333% !important;
  }

  img.rectangle-10 {
    max-width: 466px !important;
  }

  .clustor-container {
    display: flex;
    flex-direction: column !important;
    flex-wrap: nowrap;
    justify-content: center;
  }
  .MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.MuiGrid-grid-sm-6.MuiGrid-grid-md-6.css-etaaxy-MuiGrid-root {
    flex-basis: 100% !important;
    flex-grow: 0;
    max-width: 100% !important;
  }

  .clustor-main-div {
    display: flex !important;
    flex-direction: column !important;
  }
  .MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.MuiGrid-grid-sm-6.clustor-box-sub.css-1fu1a29-MuiGrid-root {
    flex-basis: 100% !important;
    flex-grow: 0;
    max-width: 100% !important;
  }
  div#devloper {
    display: flex !important;
    flex-direction: column !important;
  }
  .css-3qfvb8-MuiGrid-root {
    flex-basis: 66.666667%;
    flex-grow: 0;
    max-width: 85.666667% !important;
  }

  .css-bwvw8j-MuiGrid-root {
    flex-basis: 100.666667%;
    flex-grow: 0;
    max-width: 100.666667%;
  }
  .box-clusters {
    text-align: center !important;
    border-radius: 8px !important;
    border: 1px solid rgb(203, 197, 179) !important;
    height: 100px !important;
    width: 582px !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  /* Add your CSS styles for tablet landscape here */
}

@media (min-width: 768px) and (max-width: 1023px) and (orientation: portrait) {
  /* Add your CSS styles for tablet portrait here */
}

/* CSS for Mobile Landscape (Breakpoint range: 568px to 767px) */
@media (min-width: 568px) and (max-width: 783px) and (orientation: landscape) {
  .about-grid-mobile {
    margin-top: 0rem !important;
    display: flex;
    flex-direction: column !important;
    flex-wrap: wrap;
  }
  .about-grid {
    display: flex !important;
    justify-content: center;
    align-content: flex-start;
    flex-wrap: wrap !important;
    flex-direction: column !important;
    align-items: flex-start;
    /* margin-left: -132px !important; */
  }

  .box-1 {
    width: 470px !important;
  }

  .box-2 {
    width: 460px !important;
  }

  .last-box {
    margin-top: 0rem !important;
  }

  /* Add your CSS styles for mobile landscape here */
}

@media (min-width: 568px) and (max-width: 767px) and (orientation: portrait) {
  .about-grid-mobile {
    margin-top: 0rem !important;
    display: flex;
    flex-direction: column !important;
    flex-wrap: wrap;
  }
  .about-grid {
    display: flex !important;
    justify-content: center;
    align-content: center;
    flex-wrap: wrap !important;
    flex-direction: column !important;
    align-items: flex-start;
    margin-left: -105px !important;
  }

  /* Add your CSS styles for mobile portrait here */
}

/* CSS for Mobile Portrait (Breakpoint range: 0px to 567px) */
@media (max-width: 567px) and (orientation: landscape) {
  .about-grid-mobile {
    margin-top: -9rem !important;
  }

  .box-1 {
    width: 420px !important;
  }

  .box-2 {
    /* height: 150px !important; */

    width: 408px !important;
  }

  /* Add your CSS styles for mobile landscape here */
}

@media (max-width: 567px) and (orientation: portrait) {
  /* Add your CSS styles for mobile portrait here */
}

@media only screen and (min-width: 901px) and (max-width: 1199px) {
  .logo.css-6w6kfw {
    z-index: 5 !important;
  }
  .main-menu-container {
    /* background-color: #cbc5b3; */
    /* height: 94px; */
    /* display: none !important; */
  }
  .box-1 {
    border: none !important;
    height: 46px !important;
    align-items: flex-start !important;
    /* padding: 0px !important; */
    /* width: auto !important; */
  }

  .box-2 {
    border: none !important;
    height: 46px !important;
    align-items: flex-start !important;
    padding: 0px !important;
    /* width: auto !important; */
  }

  .last-box {
    margin-top: 4rem !important;
    /* display: none; */
    height: 113px !important;
  }
  .about-grid {
    display: flex;
    justify-content: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    flex-direction: column !important;
    align-items: flex-start;
  }

  .css-o4bg9w-MuiGrid-root {
    flex-basis: 100.666667% !important;
    flex-grow: 0;
    max-width: 100.666667% !important;
  }
  .about-des-box {
    flex-basis: 100.666667% !important;

    max-width: 100.666667% !important;
  }

  .bg-image-col {
    flex-basis: 100.333333% !important;

    max-width: 101.333333% !important;
    padding: 534px !important;
  }

  .location-options {
    flex-basis: 100.333333% !important;
    flex-grow: 0;
    max-width: 101.333333% !important;
  }
  .css-etaaxy-MuiGrid-root {
    flex-basis: 100% !important;

    max-width: 104% !important;
  }

  .css-1osj8n2-MuiGrid-root {
    flex-basis: 100% !important;
    flex-grow: 0;
    max-width: 100% !important;
  }

  .partners-container {
    display: block !important;
  }

  .aminities-container {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    margin-top: 30px !important;
    margin-bottom: 30px !important;
    border-radius: 8px !important;
    flex-wrap: wrap !important;
  }

  div#devloper {
    display: flex !important;
    flex-direction: column !important;
  }

  img.logo-devloper-ah {
    width: 60% !important;
    margin-top: 0rem !important;
    justify-content: center !important;
    flex-wrap: wrap !important;
    display: inline-flex !important;
    align-content: center !important;
    margin-left: 0rem !important;
  }

  .css-1qokjtz {
    font-family: sectionTitleFont;
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    font-size: 30px;
    font-weight: bold;
    z-index: 999999 !important;
  }
  .clustor-container {
    flex-direction: column !important;
  }
}

.css-1qokjtz {
  /* z-index: 999999 !important; */
}

.css-1lhfysi {
  /* z-index: 999999 !important; */
}

.css-fv3sos button {
  /* z-index: 999999 !important; */
}

@media (max-width: 1200px) {
  .box-1 {
    border: none !important;
    height: 60px !important;
  }

  .box-2 {
    border: none !important;
    height: 60px !important;
  }
  .css-etaaxy-MuiGrid-root {
    max-width: 100%;
    padding-right: 0px !important;
  }

  /* .css-1osj8n2-MuiGrid-root {
    flex-basis: 90% !important;

    max-width: 90% !important;
  }

  .box-clusters {
    text-align: center !important;
    border-radius: 8px !important;
    border: 1px solid rgb(203, 197, 179) !important;
    height: 100px !important;
    width: 100% !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
  } */
  p.MuiTypography-root.MuiTypography-body1.location-sub.css-naxtqj-MuiTypography-root {
    padding-left: 13px;
  }

  .bg-image-col {
    max-width: 106.333333% !important;
    padding-top: 496px !important;
    margin: auto !important;
    width: 100% !important;
    /* height: 100% !important; */
    margin-top: 2rem !important;
    margin-left: 1rem !important;
  }

  img.logo-devloper-ah {
    align-items: center !important;
  }
}

.request-btn {
  display: none !important;
}

/* menu css start here */

.request-btn-m {
  background-color: transparent !important;
}
.menu-box-right-col {
}

.MuiPaper-root.MuiPaper-elevation.MuiPaper-elevation16.MuiDrawer-paper.MuiDrawer-paperAnchorRight.css-1160xiw-MuiPaper-root-MuiDrawer-paper {
  width: 330px;
  z-index: 100049;
}

li.nav-link-btn {
  color: var(--Black, #000);
  font-family: "Helvetica Neue", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;

  list-style: none;
  text-decoration: none;
}

.nav-link-btn a {
  color: black !important;
  text-decoration: none !important;
}

.ul.menu-container {
  text-decoration: none !important;
}

.inner-header {
}
.header-content {
}

ul.menu-header {
  display: flex;
  justify-content: space-between;
  list-style: none;
  padding: 20px;
  color: var(--Black, #000);
  font-family: "Playfair Display";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
}
.request-btn-m {
  z-index: 9999px !important;
}

div#main_menu_container-inner-header {
  position: fixed;
  z-index: 99;
  top: 0;
}

.request-btn-m {
  background-color: transparent !important;
  z-index: 8;
}

.contact-btn {
}

ul.contact-menu {
  padding: 12px;
}

li.contact-list {
  border: 1px solid var(--Secondary, #cbc5b3);
  padding: 20px 10px;
  list-style: none;
  text-decoration: none;
}

li.contact-list {
  border: 1px solid var(--Secondary, #cbc5b3);
  padding: 20px 10px;
  list-style: none;
  text-decoration: none;
  color: var(--Primary, #313b2f);
  font-family: "Helvetica Neue", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
  text-decoration: none;
  text-align: center;
}

li.contact-list a {
  text-decoration: none;
  color: var(--Primary, #313b2f);
}

.contact-menu {
  width: 96%;
  position: absolute;
  bottom: 0rem;
}
.nav-link-btn {
  padding: 20px 32px;
  /* margin-bottom: 1rem; */
}

li.nav-link-btn:hover {
  background-color: #cbc5b3;
}

li.nav-link-btn {
  width: 85%;
  padding-left: 10px;
  margin-top: 1rem;
}

ul.menu-container {
  padding: 0px 20px;
}
.contact-list:hover {
  background-color: #cbc5b3;
}

[data-aos][data-aos][data-aos-duration="400"],
body[data-aos-duration="400"] [data-aos] {
  transition-duration: 3.4s !important;
}

/* .header-content {
  position: relative;
  top: 48px;
} */

img.logo.css-yb1sgc {
  width: 100px !important;
  height: auto !important;
  margin-top: 70px;
}

.request-btn-m {
  margin-top: 35px !important;
}

.MuiPaper-root.MuiPaper-elevation.MuiPaper-elevation16.MuiDrawer-paper.MuiDrawer-paperAnchorRight.css-1160xiw-MuiPaper-root-MuiDrawer-paper {
  width: 330px;
  z-index: 100049;
}

/* menu arrow css start here */

img.menu-arrow {
  float: inline-end;
  border: 1px solid;
  margin-top: 0px;
  margin-right: -22px;
  padding: 5px 2px;
  width: 20px;
}

/* padding all section css start */

@media only screen and (min-width: 1500px) and (max-width: 1920px) {
  .partners-container .partners-des {
    padding-left: 20px !important;
  }
  .Feature-container-main {
    padding-left: 120px !important;
    padding-right: 120px !important;
  }

  .experience-container-main {
    flex-basis: 100.666667% !important;

    max-width: 100.666667% !important;
  }

  .features-container {
    width: 45vw !important;
  }
  .amenities-main-section {
    padding-left: 120px !important;
    padding-right: 120px !important;
  }

  .request-btn-m {
    background-color: transparent !important;
    top: 14% !important;
    right: 65px !important;
    box-shadow: none !important;
  }

  .features-container {
    width: 84vw !important;
  }
  .about-container {
    padding-left: 120px !important;
    padding-right: 120px !important;
  }
  .location-main-section {
    padding-left: 120px !important;
    padding-right: 120px !important;
  }

  .clustor-container {
    padding-left: 120px !important;
    padding-right: 120px !important;
  }
  .devloper-container {
    padding-left: 120px !important;
    padding-right: 120px !important;
  }
  .partners-container-main {
    padding-left: 120px !important;
    padding-right: 120px !important;
  }
  .contact-container-main-section {
    padding-left: 120px !important;
    padding-right: 120px !important;
  }

  .about-sub-box {
    color: var(--Black, #000);
    font-family: "Helvetica Neue", sans-serif;
    font-size: 16px !important;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
}

@media only screen and (min-width: 1200px) and (max-width: 1500px) {
  .partners-container .partners-des {
    padding-left: 20px !important;
  }
  .request-btn-m {
    background-color: transparent !important;
    top: 11% !important;
    right: 5% !important;
    box-shadow: none !important;
  }

  .footer-menu li a {
    font-size: 16px !important;
  }

  .social-links-item a {
    font-size: 16px !important;

    text-decoration: none !important;
  }

  .logo.css-6w6kfw {
    top: 10% !important;
    left: 10% !important;
  }
  .about-container {
    padding-left: 120px !important;
    padding-right: 120px !important;
  }
  .location-main-section {
    padding-left: 120px !important;
    padding-right: 120px !important;
  }

  .clustor-container {
    padding-left: 120px !important;
    padding-right: 120px !important;
  }
  .devloper-container {
    padding-left: 120px !important;
    padding-right: 120px !important;
  }
  .partners-container-main {
    padding-left: 120px !important;
    padding-right: 120px !important;
  }
  .contact-container-main-section {
    padding-left: 120px !important;
    padding-right: 120px !important;
  }
}

@media only screen and (min-width: 200px) and (max-width: 500px) {
  .about-container {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.MuiGrid-grid-sm-3.MuiGrid-grid-xl-5.css-1q9c3ht-MuiGrid-root {
    padding-left: 0px !important;
  }

  .about-grid-mobile-boxes {
    padding-left: 0px !important;
  }

  .css-mhc70k-MuiGrid-root > .MuiGrid-item {
    padding-left: 0px !important;
  }
  .bg-image-col {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .clustor-main-div {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  .location-main-section {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .clustor-container {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  .devloper-container {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  .partners-container-main {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  .contact-container-main-section {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .clustor-boxes-section-main {
  }
}

@media only screen and (min-width: 1200px) and (max-width: 1500px) {
  .experience-container-main {
    flex-basis: 100.666667% !important;

    max-width: 90.666667% !important;
  }

  .boxs-border-cards {
    gap: 67px !important;
  }

  .discription-pera {
    font-size: 16px !important;
  }
  .discription-pera-main {
    font-size: 16px !important;
  }

  .about {
    padding-top: 10px !important;
    padding-bottom: 0px !important;
  }

  .icon-list-title {
    font-size: 16px !important;
  }

  .icon-list-heading {
    font-size: 20px !important;
  }
}

@media only screen and (min-width: 1200px) and (max-width: 1280px) {
  ul.footer-menu {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 1rem !important;
    padding: 0px;
    list-style: none;
  }
}
a.text-black-nav {
  text-decoration: none;
}
/* end */

/* end */

/* end css */
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,QAAQ;EACR,SAAS;EAIT,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,wCAAwC;EACxC,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,oDAAoD;EACpD,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;EAC3B,8BAA8B;EAC9B,oCAAoC;EACpC,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uDAAuD;AACzD;;AAEA,qEAAqE;AACrE;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IAGE,kCAAkC;IAIlC,YAAY;IACZ,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IAItB,aAAa;IACb,2BAA2B;IAG3B,eAAe;IACf,WAAW;IAGX,mBAAmB;IAGnB,kCAAkC;IAIlC,mBAAmB;IACnB,4BAA4B;IAC5B,+BAA+B;IAC/B,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,oCAAoC;EACtC;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,iCAAiC;IACjC,oCAAoC;IACpC,kCAAkC;EACpC;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,kCAAkC;IAClC,0BAA0B;IAC1B,+BAA+B;IAC/B,gCAAgC;IAChC,4BAA4B;EAC9B;;EAEA;IACE,oDAAoD;IACpD,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,+BAA+B;IAC/B,YAAY;IACZ,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;IAC7B,6BAA6B;IAC7B,+CAA+C;IAC/C,wBAAwB;IACxB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT;;kCAE8B;IAC9B,mCAAmC;IACnC,kCAAkC;IAClC,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;IACjC,6BAA6B;IAC7B,uBAAuB;IACvB,sBAAsB;IACtB,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IAGT,mBAAmB;IAGnB,sBAAsB;IAItB,YAAY;IACZ,iCAAiC;EACnC;EACA;IACE,8BAA8B;IAC9B,wBAAwB;IACxB,iCAAiC;IACjC,sCAAsC;IACtC,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;IACvB,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,yBAAyB;IACzB,4BAA4B;EAC9B;EACA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,4BAA4B;IAC5B,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,sCAAsC;IACtC,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;;IAEhB,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,wCAAwC;IACxC,4BAA4B;IAC5B,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,oBAAoB;IACpB,iCAAiC;IACjC,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,qBAAqB;IACrB,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;IACxB,gCAAgC;IAChC,4BAA4B;IAC5B,8BAA8B;IAC9B,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,6BAA6B;IAC7B,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;IAI1B,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iCAAiC;IACjC,wCAAwC;IACxC,uBAAuB;IACvB,6BAA6B;IAC7B,yBAAyB;IACzB,wCAAwC;IACxC,0BAA0B;IAC1B,kBAAkB;IAClB,2BAA2B;IAC3B,8BAA8B;IAC9B,oCAAoC;IACpC,wBAAwB;IACxB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,oBAAoB;IACpB,iCAAiC;EACnC;;EAEA;IACE,wBAAwB;IACxB,kCAAkC;IAClC,wCAAwC;IACxC,2BAA2B;IAC3B,+BAA+B;IAC/B,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iDAAiD;IACjD,YAAY;IACZ,sBAAsB;IACtB,iCAAiC;IACjC,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,QAAQ;IACR,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,oBAAoB;IACpB,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,uCAAuC;EACvC;IACE,sBAAsB;IACtB,uBAAuB;IACvB,+CAA+C;IAC/C,wBAAwB;IACxB,yCAAyC;IACzC,8BAA8B;IAC9B,qCAAqC;IACrC,2BAA2B;IAC3B,8BAA8B;IAC9B,6BAA6B;IAC7B,iCAAiC;IACjC,4BAA4B;IAC5B,oCAAoC;EACtC;AACF;;AAEA,kGAAkG;AAClG,2BAA2B;AAC3B;EACE;;;IAGE;EACF;IACE,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iDAAiD;IACjD,YAAY;IACZ,sBAAsB;IACtB,wBAAwB;IACxB,2BAA2B;IAC3B,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;AAC1B;;EAEE;IACE,uBAAuB;IACvB,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,6BAA6B;EAC/B;EACA;IACE,YAAY;EACd;EACA;IACE,8BAA8B;IAC9B,wBAAwB;IACxB,iCAAiC;IACjC,2BAA2B;IAC3B,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;IACvB,kCAAkC;EACpC;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iDAAiD;IACjD,YAAY;IACZ,sBAAsB;IACtB,wBAAwB;IACxB,2BAA2B;IAC3B,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IAIpB,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,wCAAwC;IACxC,mBAAmB;IACnB,WAAW;IACX,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;EACd;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;IACvB,kCAAkC;EACpC;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iDAAiD;IACjD,YAAY;IACZ,sBAAsB;IACtB,wBAAwB;IACxB,2BAA2B;IAC3B,aAAa;EACf;;EAEA;IACE,8BAA8B;IAC9B,wBAAwB;IACxB,iCAAiC;IACjC,2BAA2B;IAC3B,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;IACvB,kCAAkC;EACpC;AACF;AACA;EACE;IACE,uBAAuB;IACvB,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;IACvB,kCAAkC;EACpC;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iDAAiD;IACjD,YAAY;IACZ,sBAAsB;IACtB,wBAAwB;IACxB,2BAA2B;IAC3B,aAAa;EACf;EACA;IACE,8BAA8B;IAC9B,wBAAwB;IACxB,iCAAiC;IACjC,2BAA2B;IAC3B,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;IACvB,kCAAkC;EACpC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;IAC9B,yBAAyB;IACzB,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;IAC9B,wBAAwB;IACxB,iCAAiC;IACjC,2BAA2B;IAC3B,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;AACA,KAAK;;AAEL;EACE,+DAA+D;;EAE/D;IACE,6BAA6B;IAC7B,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,wBAAwB;EAC1B;AACF;;AAEA,6FAA6F;;AAE7F;EACE;IACE,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;EACjB;;EAEA,yDAAyD;AAC3D;;AAEA,2EAA2E;;AAE3E;EACE,6CAA6C;AAC/C;;AAEA,kBAAkB;;AAElB;EACE,cAAc;EACd,2CAA2C;EAC3C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,SAAS;;AAET,qBAAqB;AACrB;EACE,+BAA+B;AACjC;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,mBAAmB;;AAEnB;EACE,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EAItB,aAAa;EACb,2BAA2B;EAG3B,eAAe;EACf,WAAW;EAGX,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EAIjB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,iCAAiC;EACjC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,oDAAoD;EACpD,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,4CAA4C;EAC5C,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,oCAAoC;EACpC,YAAY;EACZ,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,oDAAoD;EACpD,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,oDAAoD;EACpD,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,wCAAwC;EACxC,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,oDAAoD;EACpD,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;EAC3B,8BAA8B;EAC9B,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,SAAS;;AAET,QAAQ;;AAER,0BAA0B;;AAE1B;EACE,6CAA6C;EAC7C;IACE,6BAA6B;IAC7B,oBAAoB;EACtB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;;;;;KAKG;EACH;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;EACA;IACE,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA,SAAS;;AAET,QAAQ;;AAER,iBAAiB;AACjB;EACE,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA,qCAAqC;;AAErC;;EAEE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;AACA,QAAQ;;AAER;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,+BAA+B;IAC/B,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;IAC9B,yBAAyB;IACzB,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,qDAAqD;AACrD;EACE,0DAA0D;;EAE1D;IACE,wCAAwC;IACxC,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,yDAAyD;;EAEzD;IACE,uBAAuB;EACzB;AACF;;AAEA,kEAAkE;AAClE;EACE;IACE,8BAA8B;IAC9B,yBAAyB;IACzB,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;EACrB;EACA,kDAAkD;AACpD;;AAEA;EACE;IACE,8BAA8B;IAC9B,yBAAyB;IACzB,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;;IAE9B,uBAAuB;EACzB;;EAEA,iDAAiD;AACnD;AACA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;IACf,iCAAiC;IACjC,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;EACA;IACE,iCAAiC;;IAEjC,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;EACA;IAGE,2BAA2B;IAI3B,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IAGE,2BAA2B;IAI3B,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,6BAA6B;IAC7B,+CAA+C;IAC/C,wBAAwB;IACxB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,4BAA4B;IAC5B,uBAAuB;IACvB,0BAA0B;IAC1B,+BAA+B;IAC/B,4BAA4B;IAC5B,4BAA4B;IAC5B,sBAAsB;EACxB;EACA;IAGE,sBAAsB;IAItB,YAAY;IACZ,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,kCAAkC;;IAElC,iCAAiC;EACnC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA,gEAAgE;AAChE;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;IACxB,kCAAkC;IAClC,oCAAoC;IACpC,0BAA0B;IAC1B,iCAAiC;IACjC,kCAAkC;EACpC;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;EACA;IACE,kCAAkC;IAClC,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,iCAAiC;IACjC,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,2BAA2B;IAI3B,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;EACnC;EACA;IACE,2BAA2B;IAI3B,YAAY;IACZ,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,iCAAiC;EACnC;EACA;IAGE,sBAAsB;IAItB,YAAY;IACZ,gCAAgC;EAClC;;EAEA;IAGE,uBAAuB;IAIvB,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,6BAA6B;IAC7B,6BAA6B;IAC7B,+CAA+C;IAC/C,wBAAwB;IACxB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,kDAAkD;AACpD;;AAEA;EACE,iDAAiD;AACnD;;AAEA,gEAAgE;AAChE;EACE;IACE,2BAA2B;IAC3B,aAAa;IACb,iCAAiC;IACjC,eAAe;EACjB;EACA;IACE,wBAAwB;IACxB,uBAAuB;IACvB,yBAAyB;IACzB,0BAA0B;IAC1B,iCAAiC;IACjC,uBAAuB;IACvB,oCAAoC;EACtC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA,kDAAkD;AACpD;;AAEA;EACE;IACE,2BAA2B;IAC3B,aAAa;IACb,iCAAiC;IACjC,eAAe;EACjB;EACA;IACE,wBAAwB;IACxB,uBAAuB;IACvB,qBAAqB;IACrB,0BAA0B;IAC1B,iCAAiC;IACjC,uBAAuB;IACvB,8BAA8B;EAChC;;EAEA,iDAAiD;AACnD;;AAEA,6DAA6D;AAC7D;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;;IAE9B,uBAAuB;EACzB;;EAEA,kDAAkD;AACpD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,+BAA+B;IAC/B,kBAAkB;IAClB,8BAA8B;EAChC;EACA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,kCAAkC;IAClC,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,kCAAkC;IAClC,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;IAC3B,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,yBAAyB;IACzB,eAAe;IACf,iCAAiC;IACjC,uBAAuB;EACzB;;EAEA;IAGE,kCAAkC;IAIlC,YAAY;IACZ,iCAAiC;EACnC;EACA;IACE,kCAAkC;;IAElC,iCAAiC;EACnC;;EAEA;IACE,kCAAkC;;IAElC,iCAAiC;IACjC,yBAAyB;EAC3B;;EAEA;IAGE,kCAAkC;IAIlC,YAAY;IACZ,iCAAiC;EACnC;EACA;IACE,2BAA2B;;IAE3B,0BAA0B;EAC5B;;EAEA;IAGE,2BAA2B;IAI3B,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;IACxB,yCAAyC;IACzC,8BAA8B;IAC9B,2BAA2B;IAC3B,8BAA8B;IAC9B,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;EACnC;;EAEA;IACE,qBAAqB;IACrB,2BAA2B;IAC3B,kCAAkC;IAClC,0BAA0B;IAC1B,+BAA+B;IAC/B,gCAAgC;IAChC,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,kBAAkB;IAClB,QAAQ;IACR,SAAS;IAIT,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,0BAA0B;EAC5B;EACA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,6BAA6B;EAC/B;;EAEA;;;;;;;;;;;;;;;KAeG;EACH;IACE,kBAAkB;EACpB;;EAEA;IACE,iCAAiC;IACjC,6BAA6B;IAC7B,uBAAuB;IACvB,sBAAsB;IACtB,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,wBAAwB;;AAExB;EACE,wCAAwC;AAC1C;AACA;AACA;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;;EAEzB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;AACA;AACA;AACA;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,MAAM;AACR;;AAEA;EACE,wCAAwC;EACxC,UAAU;AACZ;;AAEA;AACA;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;EAC9B,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;;GAGG;;AAEH;EACE,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,8BAA8B;;AAE9B;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA,kCAAkC;;AAElC;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,kCAAkC;;IAElC,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,wCAAwC;IACxC,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;IACzB,yCAAyC;IACzC,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,wCAAwC;IACxC,mBAAmB;IACnB,oBAAoB;IACpB,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;;IAE1B,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;EACA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;EACA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;EACA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;EACA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;EACA;AACF;;AAEA;EACE;IACE,kCAAkC;;IAElC,gCAAgC;EAClC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;IACb,2BAA2B;IAC3B,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA;EACE,qBAAqB;AACvB;AACA,QAAQ;;AAER,QAAQ;;AAER,YAAY","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\np#contactsection {\n  color: #000;\n  font-family: \"Playfair Display\" !important;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\nelement.style {\n  font-family: sectionTitleFont;\n  color: white;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow-x: hidden;\n}\n\n.title-video-container.css-1qokjtz {\n  font-family: sectionTitleFont;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  text-align: center;\n  color: white;\n  font-size: 62px;\n  font-style: normal;\n  font-weight: 500;\n  padding-bottom: 83px;\n  z-index: 9999 !important;\n}\n\n.SubTitle-video-container.css-1lhfysi {\n  padding-top: 92px;\n  color: var(--White, #fff);\n  font-family: \"Helvetica Neue\", sans-serif;\n  font-size: 19px;\n  font-style: normal;\n  font-weight: 300;\n  line-height: normal;\n  top: 53%;\n  z-index: 9999 !important;\n}\n\n.broucher-btn {\n  margin-top: 2rem !important;\n  border: 1px solid var(--White, #fff) !important;\n  background-color: transparent !important;\n  color: white !important;\n  padding: 16px 32px !important;\n  color: var(--White, #fff);\n  font-family: \"Helvetica Neue\", sans-serif !important;\n  font-size: 18px !important;\n  font-style: normal;\n  font-weight: 400 !important;\n  line-height: normal !important;\n  text-transform: uppercase !important;\n  top: 73% !important;\n  z-index: 9999 !important;\n}\n\np {\n  color: #000;\n  font-family: \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: 300;\n  line-height: normal;\n}\n\n.broucher-btn:hover {\n  background-color: white !important;\n  color: #000 !important;\n  border: none !important;\n}\n\n.main-menu button:hover {\n  background-color: transparent;\n}\n\n.main-menu button {\n  align-items: center !important;\n  color: var(--Black, #000);\n  font-family: \"Helvetica Neue\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-transform: uppercase;\n}\n\n.main-menu-container {\n  /* background: #cbc5b3; */\n  /* box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.08); */\n}\n\n/* Styles for screens smaller than 600px (typically mobile devices) */\n@media only screen and (max-width: 900px) {\n  ul.footer-menu {\n    display: none !important;\n  }\n  .logo.css-6w6kfw {\n    z-index: 5 !important;\n  }\n  .contact-row-ipad{\n    width: 100% !important;\n    margin-left: 0 !important;\n  }\n\n  .css-o4bg9w-MuiGrid-root {\n    -webkit-flex-basis: 66.666667%;\n    -ms-flex-preferred-size: 66.666667%;\n    flex-basis: 100.666667% !important;\n    -webkit-box-flex: 0;\n    -webkit-flex-grow: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    max-width: 100.666667% !important;\n  }\n  .about-grid-mobile {\n    padding-left: 1px !important;\n  }\n\n  .css-1ild15j-MuiGrid-root {\n    box-sizing: border-box;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex-wrap: wrap;\n    -webkit-flex-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    width: 100%;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-box-pack: justify;\n    -webkit-justify-content: space-between !important;\n    justify-content: center !important;\n    -webkit-align-items: center;\n    -webkit-box-align: center !important;\n    -ms-flex-align: center !important;\n    align-items: center;\n    padding-top: 32px !important;\n    padding-bottom: 32px !important;\n    align-content: center !important;\n  }\n\n  .MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-1.MuiGrid-direction-xs-column.Content-bullets.css-h7pwju-MuiGrid-root {\n    padding-top: 0px !important;\n  }\n\n  .css-qi3ouq-MuiGrid-root {\n    padding-top: 25px !important;\n  }\n\n  .discription-pera {\n    text-align: justify !important;\n  }\n\n  .discription-pera-main {\n    text-align: justify !important;\n  }\n\n  .estate {\n    padding: 0px !important;\n    color: black !important;\n    opacity: 1 !important;\n    text-align: left;\n    padding-left: 50px;\n    font-weight: 600 !important;\n    padding-left: 0rem !important;\n  }\n\n  img.rectangle-10 {\n    max-width: 300px !important;\n  }\n\n  .features-container {\n    padding-right: 20px;\n    padding: 30px 0px 0px 0px !important;\n  }\n\n  .location-options {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    flex-direction: column !important;\n    align-content: flex-start !important;\n    justify-content: center !important;\n  }\n  .MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-1.MuiGrid-direction-xs-column.Content-bullets.css-h7pwju-MuiGrid-root {\n    padding-top: 122px;\n  }\n\n  img.partners-logo {\n    width: 150px;\n    margin-bottom: 25px !important;\n  }\n\n  div#root {\n    overflow: hidden !important;\n  }\n  .about-grid-mobile {\n    margin-top: -18rem !important;\n  }\n  img.logo-devloper-ah {\n    width: 100% !important;\n    margin-top: 0rem !important;\n    justify-content: center !important;\n    flex-wrap: wrap !important;\n    display: inline-flex !important;\n    align-content: center !important;\n    margin-left: 0rem !important;\n  }\n\n  .discription-pera {\n    font-family: \"Helvetica Neue\", sans-serif !important;\n    font-size: 20px !important;\n    font-style: normal;\n    font-weight: 300;\n    line-height: normal;\n    padding-bottom: 20px !important;\n    opacity: 0.6;\n    color: black;\n    margin-bottom: 40px;\n  }\n  .contact-text-container-2 {\n    display: block;\n    width: 410px;\n    margin-left: 20px !important;\n  }\n\n  .card-section {\n    width: 80% !important;\n    margin-left: 0px !important;\n  }\n\n  .box-clusters {\n    text-align: center !important;\n    border-radius: 8px !important;\n    border: 1px solid rgb(203, 197, 179) !important;\n    height: 100px !important;\n    width: 270px !important;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n\n  body {\n    margin: 0;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\",\n      \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\",\n      \"Helvetica Neue\", sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    overflow-x: hidden !important;\n  }\n\n  .last-box {\n    margin-top: 4rem !important;\n  }\n\n  .bg-image-col {\n    max-width: 106.333333% !important;\n    padding-top: 496px !important;\n    margin: auto !important;\n    width: 100% !important;\n    /* height: 100% !important; */\n    margin-top: 2rem !important;\n    margin-left: 0rem !important;\n  }\n\n  .css-zqi6k4-MuiGrid-root {\n    box-sizing: border-box;\n    margin: 0;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-flex-basis: 83.333333%;\n    -ms-flex-preferred-size: 83.333333%;\n    flex-basis: 83.333333%;\n    -webkit-box-flex: 0;\n    -webkit-flex-grow: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    max-width: 100.333333% !important;\n  }\n  .box-2 {\n    /* height: 150px !important; */\n    display: flex !important;\n    flex-direction: column !important;\n    justify-content: flex-start !important;\n    margin-top: 1rem;\n    height: 113px !important;\n    margin-top: 1rem;\n    width: 278px !important;\n    padding-left: 20px !important;\n    text-align: left !important;\n  }\n\n  img.gallery-control-btn {\n    width: 30px !important;\n  }\n  .gallery-image {\n    width: 100% !important;\n    height: 426px !important;\n    display: block !important;\n    margin: 0 auto !important;\n    object-fit: cover !important;\n  }\n  .estate {\n    padding: 0px !important;\n    color: black !important;\n    opacity: 1 !important;\n    text-align: left;\n    padding-left: 0px !important;\n    font-weight: 600 !important;\n    text-align: center !important;\n  }\n\n  .box-1 {\n    display: flex !important;\n    flex-direction: column !important;\n    justify-content: flex-start !important;\n    margin-top: 1rem;\n    height: 100px !important;\n    margin-top: 1rem;\n\n    width: 286px !important;\n    text-align: left !important;\n  }\n\n  .grid-mobile-aboutus {\n    display: flex !important;\n    flex-direction: column !important;\n    justify-content: space-around !important;\n    flex-wrap: nowrap !important;\n    align-items: center;\n  }\n  .partners-container {\n    display: flex;\n    align-content: center;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: nowrap;\n    padding-bottom: 57px;\n    flex-direction: column !important;\n    display: block !important;\n    padding: 0px !important;\n  }\n\n  .estate {\n    padding: 0px !important;\n    color: black !important;\n    opacity: 1 !important;\n    text-align: center !important;\n    padding-left: 0px !important;\n    font-weight: 600 !important;\n  }\n\n  ul.clustor-list li {\n    display: flex !important;\n    align-content: center !important;\n    flex-wrap: nowrap !important;\n    flex-direction: row !important;\n    align-items: center !important;\n    padding-bottom: 26px !important;\n  }\n  .title-video-container.css-1qokjtz {\n    font-family: sectionTitleFont;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    text-align: center;\n    color: white;\n    font-size: 41px !important;\n    font-style: normal;\n    font-weight: 500;\n    padding-bottom: 70px;\n    z-index: 9999 !important;\n  }\n\n  .css-6w6kfw {\n    position: absolute;\n    top: 10% !important;\n    /* left: 50% !important; */\n    -webkit-transform: translate(-50%, -50%);\n    -moz-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    text-align: center;\n    color: white;\n    font-weight: bold;\n  }\n\n  .request-btn {\n    border: 1px solid #fff !important;\n    background-color: transparent !important;\n    color: white !important;\n    padding: 16px 32px !important;\n    color: var(--White, #fff);\n    font-family: \"Helvetica Neue\" !important;\n    font-size: 18px !important;\n    font-style: normal;\n    font-weight: 400 !important;\n    line-height: normal !important;\n    text-transform: uppercase !important;\n    display: none !important;\n    z-index: 9999 !important;\n  }\n\n  .partners-container {\n    display: flex;\n    align-content: center;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: nowrap;\n    padding-bottom: 57px;\n    flex-direction: column !important;\n  }\n\n  .aminities-container {\n    display: flex !important;\n    align-items: flex-start !important;\n    justify-content: space-around !important;\n    align-content: space-around;\n    padding-bottom: 30px !important;\n    margin-left: 0px !important;\n    flex-direction: column !important;\n  }\n\n  .card-section {\n    border-radius: 16px;\n    background: #313b2f;\n    box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32);\n    color: white;\n    /* margin: 7px 14px; */\n    /* text-align: left !important; */\n    height: 538px;\n    width: 60%;\n  }\n\n  .SubTitle-video-container.css-1lhfysi {\n    padding-top: 92px;\n    color: var(--White, #fff);\n    font-family: \"Helvetica Neue\", sans-serif;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 300;\n    line-height: normal;\n    top: 57%;\n    z-index: 9999 !important;\n  }\n\n  div#root body {\n    overflow-x: hidden;\n  }\n\n  .card-features {\n    padding-bottom: 36px;\n  }\n\n  .partners-container {\n    display: flex;\n    align-content: center;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    padding-bottom: 57px;\n    flex-direction: column !important;\n  }\n\n  p.partners-para {\n    padding-left: 0px;\n    text-align: center;\n  }\n\n  img.partners-logo {\n    width: 171px;\n  }\n}\n\n@media only screen and (max-width: 599px) {\n  /* Your CSS styles for mobile devices */\n  .features-container {\n    width: 100% !important;\n    height: auto !important;\n    background-color: rgb(203, 197, 179) !important;\n    display: flex !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n    padding: 40px 0px 0px 10px !important;\n    margin-top: 30px !important;\n    margin-bottom: 30px !important;\n    border-radius: 8px !important;\n    flex-direction: column !important;\n    flex-wrap: nowrap !important;\n    align-content: flex-start !important;\n  }\n}\n\n/* Styles for screens between 600px and 959px (typically larger smartphones and smaller tablets) */\n/* web screen media start */\n@media only screen and (min-width: 1500px) and (max-width: 1600px) {\n  /*.MuiGrid-container {\n      padding-left: 50px !important;\n      padding-right: 50px !important;\n  }*/\n  footer .MuiGrid-root.MuiGrid-item.css-13i4rnv-MuiGrid-root {\n    width: 300px;\n  }\n  .estate {\n    padding: 0px !important;\n    color: black !important;\n    opacity: 1 !important;\n    text-align: left;\n    padding-left: 50px;\n    font-weight: 600 !important;\n    padding-left: 2rem !important;\n  }\n\n  .card-section {\n    border-radius: 16px;\n    background: #313b2f;\n    box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32);\n    color: white;\n    /* margin: 7px 14px; */\n    padding: 32px !important;\n    text-align: left !important;\n    height: 538px;\n  }\n}\n\n@media only screen and (min-width: 1440px) and (max-width: 1440px) {\n  .features-container.aos-init.aos-animate {\n    width: 86vw !important;\n    padding: 0px 27px !important;\n  }\n\n  .about {\n    width: 100% !important;\n}\n\n  .estate {\n    padding: 0px !important;\n    color: black !important;\n    opacity: 1 !important;\n    text-align: left;\n    padding-left: 50px;\n    font-weight: 600 !important;\n    padding-left: 2rem !important;\n  }\n  footer .MuiGrid-root.MuiGrid-item.css-13i4rnv-MuiGrid-root {\n    width: 300px;\n  }\n  .box-2 {\n    /* height: 150px !important; */\n    display: flex !important;\n    flex-direction: column !important;\n    justify-content: flex-start;\n    margin-top: 1rem;\n    height: 100px !important;\n    margin-top: 1rem;\n    width: 390px !important;\n  }\n\n  .box-1 {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    height: 100px !important;\n    margin-top: 1rem;\n    width: 173px !important;\n    align-items: flex-start !important;\n  }\n\n  .card-section {\n    border-radius: 16px;\n    background: #313b2f;\n    box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32);\n    color: white;\n    /* margin: 7px 14px; */\n    padding: 32px !important;\n    text-align: left !important;\n    height: 538px;\n  }\n}\n\n@media only screen and (min-width: 1200px) {\n  .css-6w6kfw {\n    position: absolute;\n    top: 10% !important;\n    left: 10% !important;\n    -webkit-transform: translate(-50%, -50%);\n    -moz-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    text-align: center;\n    color: white;\n    font-weight: bold;\n    z-index: 10000;\n  }\n\n  .request-btn-m {\n    background-color: transparent !important;\n    top: 14% !important;\n    right: 65px;\n    box-shadow: none !important;\n  }\n}\n\n@media only screen and (min-width: 1920px) and (max-width: 1920px) {\n  img.rectangle-10 {\n    max-width: 90% !important;\n  }\n\n  footer .MuiGrid-root.MuiGrid-item.css-13i4rnv-MuiGrid-root {\n    width: 300px;\n  }\n  .location-options {\n    margin-top: 130px !important;\n  }\n  .estate {\n    padding: 0px !important;\n    color: black !important;\n    opacity: 1 !important;\n    text-align: left;\n    padding-left: 50px;\n    font-weight: 600 !important;\n    margin-left: 2rem !important;\n  }\n\n  .box-1 {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    height: 113px !important;\n    margin-top: 1rem;\n    width: 230px !important;\n    align-items: flex-start !important;\n  }\n\n  .card-section {\n    border-radius: 16px;\n    background: #313b2f;\n    box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32);\n    color: white;\n    /* margin: 7px 14px; */\n    padding: 73px !important;\n    text-align: left !important;\n    height: 538px;\n  }\n\n  .box-2 {\n    /* height: 150px !important; */\n    display: flex !important;\n    flex-direction: column !important;\n    justify-content: flex-start;\n    margin-top: 1rem;\n    height: 113px !important;\n    margin-top: 1rem;\n    width: 506px !important;\n    align-items: flex-start !important;\n  }\n}\n@media only screen and (min-width: 1600px) and (max-width: 1600px) {\n  .estate {\n    padding: 0px !important;\n    color: black !important;\n    opacity: 1 !important;\n    text-align: left;\n    padding-left: 50px;\n    font-weight: 600 !important;\n    margin-left: 2rem !important;\n  }\n\n  .box-1 {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    height: 113px !important;\n    margin-top: 1rem;\n    width: 197px !important;\n    align-items: flex-start !important;\n  }\n\n  .card-section {\n    border-radius: 16px;\n    background: #313b2f;\n    box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32);\n    color: white;\n    /* margin: 7px 14px; */\n    padding: 32px !important;\n    text-align: left !important;\n    height: 538px;\n  }\n  .box-2 {\n    /* height: 150px !important; */\n    display: flex !important;\n    flex-direction: column !important;\n    justify-content: flex-start;\n    margin-top: 1rem;\n    height: 113px !important;\n    margin-top: 1rem;\n    width: 430px !important;\n    align-items: flex-start !important;\n  }\n  .about-sub-box {\n    font-size: 15px !important;\n  }\n  .location-options {\n    margin-top: 130px !important;\n  }\n}\n@media only screen and (min-width: 1366px) and (max-width: 1366px) {\n  .location-options {\n    margin-top: 130px !important;\n  }\n  footer .MuiGrid-root.MuiGrid-item.css-13i4rnv-MuiGrid-root {\n    width: 300px;\n  }\n  .estate {\n    padding: 0px !important;\n    color: black !important;\n    opacity: 1 !important;\n    text-align: left;\n    padding-left: 50px;\n    font-weight: 600 !important;\n    margin-left: 2rem !important;\n  }\n\n  .estate {\n    padding: 0px !important;\n    color: black !important;\n    opacity: 1 !important;\n    text-align: left;\n    padding-left: 50px;\n    font-weight: 600 !important;\n    padding-left: 2rem !important;\n  }\n\n  .main-menu button {\n    align-items: center !important;\n    color: var(--Black, #000);\n    font-family: \"Helvetica Neue\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    text-transform: uppercase;\n    padding-right: 0rem !important;\n  }\n\n  .box-1 {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    height: 113px !important;\n    margin-top: 1rem;\n    width: 160px !important;\n  }\n\n  .box-2 {\n    /* height: 150px !important; */\n    display: flex !important;\n    flex-direction: column !important;\n    justify-content: flex-start;\n    margin-top: 1rem;\n    height: 113px !important;\n    margin-top: 1rem;\n    width: 342px !important;\n  }\n}\n/*  */\n\n@media only screen and (min-width: 600px) and (max-width: 959px) {\n  /* Your CSS styles for larger smartphones and smaller tablets */\n\n  .title-video-container.css-1qokjtz {\n    font-family: sectionTitleFont;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    text-align: center;\n    color: white;\n    font-size: 41px;\n    font-style: normal;\n    font-weight: 500;\n    padding-bottom: 83px;\n    z-index: 9999 !important;\n  }\n}\n\n/* Styles for screens between 960px and 1279px (typically larger tablets and small laptops) */\n\n@media only screen and (min-width: 250px) and (max-width: 390px) {\n  .boxs-border-cards {\n    display: flex;\n    gap: 44px;\n    flex-direction: column;\n    width: 260px !important;\n    align-items: flex-start;\n    padding-left: 29px;\n    max-width: 100%;\n  }\n\n  /* Your CSS styles for larger tablets and small laptops */\n}\n\n/* Styles for screens larger than 1280px (typically desktops and laptops) */\n\n@media only screen and (min-width: 1280px) {\n  /* Your CSS styles for desktops and laptops */\n}\n\n/* web css start */\n\n.title {\n  color: #313b2f;\n  font-family: \"Playfair Display\", sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-transform: uppercase;\n}\n\n/* end  */\n\n/* mustfa css start */\n.about {\n  font-family: \"Playfair Display\";\n}\n.about-body {\n  font-family: \"Helvetica Neue\";\n  opacity: 60%;\n  font-size: 24px;\n  font-weight: 300;\n  line-height: 29px;\n}\n\n/* body font css  */\n\n.css-iaplqc-MuiTypography-root {\n  font-family: \"Playfair Display\", sans-serif !important;\n}\n\n.partners-container {\n  display: flex;\n  align-content: center;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  padding-bottom: 47px;\n  margin-left: 2rem;\n}\n\np.partners-para {\n  padding-left: 47px;\n  color: #000;\n  font-family: \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: 300;\n  line-height: normal;\n}\n\nimg.rectangle-10 {\n  /* max-width: 90% !important; */\n}\n\n.location-options {\n  display: flex;\n  flex-wrap: nowrap;\n  flex-direction: row;\n}\n\n.Content-bullets {\n  padding-left: 10px !important;\n  color: var(--Black, #000);\n  font-family: \"Helvetica Neue\", sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 300;\n  line-height: normal;\n}\n\n.location-sub {\n  color: var(--Black, #000);\n  font-family: \"Playfair Display\" !important;\n  font-size: 32px !important;\n  font-style: normal !important;\n  font-weight: 500 !important;\n  line-height: normal !important;\n  text-transform: uppercase !important;\n  padding-bottom: 10px !important;\n}\n\n.location-head {\n  color: var(--Black, #000) !important;\n  font-family: \"Playfair Display\" !important;\n  font-size: 20px !important;\n  font-style: normal !important;\n  font-weight: 500 !important;\n  line-height: normal !important;\n}\n\n.main-menu button {\n  align-items: center !important;\n  color: var(--Black, #000);\n  font-family: \"Helvetica Neue\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-transform: uppercase;\n  padding-right: 0rem;\n}\n\n.css-gjpydu-MuiGrid-root {\n  box-sizing: border-box;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  width: 100%;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  margin-top: -16px;\n  width: calc(100% + 20px);\n  margin-left: 9px;\n  max-width: 1536px;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -webkit-justify-content: center;\n  justify-content: flex-start;\n}\n\nimg.rectangle-8 {\n  width: 100%;\n}\n\n.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2.main-menu.css-gjpydu-MuiGrid-root {\n  justify-content: flex-start;\n  margin-left: 6px;\n}\n\nimg.icon-clustor {\n  padding-right: 20px;\n}\n\nul.clustor-list li {\n  display: flex;\n  align-content: center;\n  flex-wrap: wrap;\n  flex-direction: row;\n  align-items: center;\n  padding-bottom: 26px;\n}\n\n.box-2 {\n  /* height: 150px !important; */\n  display: flex !important;\n  flex-direction: column !important;\n  justify-content: flex-start;\n  margin-top: 1rem;\n}\n\n.box-1 {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  /* height: 150px !important; */\n  margin-top: 1rem;\n}\n\n.about {\n  color: var(--Black, #000);\n  font-family: \"Playfair Display\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  padding-bottom: 1px;\n  padding-top: 16px;\n}\n\n.about-grid {\n  display: flex;\n  justify-content: flex-start;\n  align-content: center;\n  flex-wrap: wrap;\n  flex-direction: row;\n}\n\np#aboutsection {\n  color: var(--Secondary, #cbc5b3);\n  font-family: \"Playfair Display\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.location-head {\n  color: var(--Black, #000) !important;\n  font-family: \"Playfair Display\" !important;\n  font-size: 32px !important;\n  font-style: normal !important;\n  font-weight: 500 !important;\n  line-height: normal !important;\n  padding-bottom: 10px !important;\n  padding-top: 20px !important;\n}\n\n.discription-pera {\n  font-family: \"Helvetica Neue\", sans-serif !important;\n  font-size: 20px !important;\n  font-style: normal;\n  font-weight: 300;\n  line-height: normal;\n  padding-bottom: 20px !important;\n  opacity: 0.6;\n  color: black;\n}\n\n.about {\n  color: var(--Black, #000);\n  font-family: \"Playfair Display\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  opacity: 0.6;\n  padding-bottom: 20px;\n}\n\n.about-sub-box {\n  color: var(--Black, #000);\n  font-family: \"Helvetica Neue\";\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.discription-pera-main {\n  /*font-family: \"Helvetica Neue\" !important;*/\n  font-size: 20px !important;\n  font-style: normal;\n  font-weight: 300;\n  line-height: normal;\n  padding-bottom: 20px !important;\n  opacity: 0.6;\n  /* color: black; */\n  color: navajowhite;\n}\n\n.clustor-box-title {\n  color: var(--White, #fff);\n  font-family: \"Playfair Display\" !important;\n  font-size: 16px !important;\n  font-style: normal;\n  font-weight: 400 !important;\n  line-height: normal;\n  text-transform: uppercase !important;\n  opacity: 0.6;\n  padding-bottom: 21px !important;\n  text-align: left !important;\n}\n\n.clustor-box-sub {\n  color: var(--White, #fff);\n  font-family: \"Helvetica Neue\", sans-serif !important;\n  font-size: 16px !important;\n  font-style: normal !important;\n  font-weight: 400 !important;\n  line-height: normal !important;\n  text-align: left !important;\n}\n\n.estate {\n  padding: 0px !important;\n  color: black !important;\n  opacity: 1 !important;\n  text-align: left;\n  padding-left: 50px;\n  font-weight: 600 !important;\n}\n.aminites {\n  padding-bottom: 0px !important;\n  padding-top: 0px !important;\n}\n\n.contact-icons {\n  font-family: \"Helvetica Neue\", sans-serif !important;\n  font-size: 20px !important;\n  margin-bottom: 40px !important;\n}\n.icon-socails {\n  font-size: 30px !important;\n  width: 2em !important;\n}\n.contact-icons span {\n  position: relative;\n  top: -8px;\n  opacity: 0.8;\n}\n\n.contact-text-container-2 {\n  padding: 30px 60px 60px 0 !important;\n}\n\n.request-btn {\n  border: 1px solid #fff !important;\n  background-color: transparent !important;\n  color: white !important;\n  padding: 16px 32px !important;\n  color: var(--White, #fff);\n  font-family: \"Helvetica Neue\", sans-serif !important;\n  font-size: 18px !important;\n  font-style: normal;\n  font-weight: 400 !important;\n  line-height: normal !important;\n  text-transform: uppercase !important;\n  z-index: 9999 !important;\n}\n\n.request-btn:hover {\n  background-color: white !important;\n  color: #000 !important;\n}\n\n.features-container {\n  padding-right: 20px;\n  padding: 0px 23px;\n}\n\n/* end  */\n\n/* end */\n\n/* mustfa css start here */\n\n@media screen and (max-width: 426px) {\n  /* Your CSS styles for desktops and laptops */\n  .copyright {\n    padding-left: 60px !important;\n    padding-bottom: 10px;\n  }\n  .terms {\n    padding-left: 80px !important;\n  }\n  .partners-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n  /* .partners-des-1{\n    padding-top: 160px;\n  }\n  .parners-logo{\n   margin: 10px;\n  } */\n  .form-info-text {\n    font-size: 20px;\n    margin-bottom: 40px;\n  }\n  .customGridPadding {\n    flex-basis: none !important;\n    max-width: 100% !important;\n  }\n  .contact-text-container-2 {\n    display: block;\n    width: 400px;\n  }\n}\n\n.header-button {\n  margin-left: 180px !important;\n}\n.header-logo {\n  margin-right: 200px;\n}\n/* end  */\n\n/* end */\n\n/* contact form */\n.input-field {\n  width: 467px !important;\n}\n.customGridHeight {\n  padding-top: 10px;\n  padding-bottom: 10px;\n  /* Adjust this value to your desired height */\n}\n\n/* input css contact css start here */\n\n.css-md26zr-MuiInputBase-root-MuiOutlinedInput-root.Mui-focused\n  .MuiOutlinedInput-notchedOutline {\n  border-color: #ffffff !important;\n  border-width: 2px !important;\n}\n\n.css-14lo706 > span {\n  padding-left: 5px;\n  padding-right: 5px;\n  display: inline-block;\n  opacity: 0;\n  font-size: 20px !important;\n  visibility: visible;\n}\n\n.contact-icons {\n  display: flex;\n  align-content: flex-start;\n}\n\nsvg.MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium.icon-socails.css-4guzyp-MuiSvgIcon-root {\n  width: 40px;\n  height: 40px;\n  margin-top: -11px;\n}\n.css-1410706 > span {\n  font-size: 20px !important;\n}\n\n.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input:focus {\n  border: 0;\n}\nfooter {\n  padding: 0px 40px;\n}\n.css-w2rlnz-MuiTypography-root {\n  float: left;\n}\n\n.video-container {\n  z-index: 9999 !important;\n}\n/* end */\n\n@media (max-width: 1199px) {\n  .css-fv3sos button {\n    z-index: 5 !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .box-1 {\n    border: none !important;\n  }\n\n  .box-2 {\n    border: none !important;\n  }\n\n  .about {\n    color: var(--Black, #000);\n    font-family: \"Playfair Display\";\n    font-size: 15px !important;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    opacity: 0.6;\n    padding-bottom: 20px;\n  }\n\n  .about-sub-box {\n    color: var(--Black, #000);\n    font-family: \"Helvetica Neue\";\n    font-size: 13px !important;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n}\n\n/* breakpoint css start here */\n@media only screen and (min-width: 1280px) and (max-width: 1426px) {\n  .box-1 {\n    width: 150px !important;\n  }\n\n  .box-2 {\n    width: 330px !important;\n  }\n\n  .main-menu button {\n    align-items: center !important;\n    color: var(--Black, #000);\n    font-family: \"Helvetica Neue\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    text-transform: uppercase;\n    padding-right: 0.6rem !important;\n  }\n\n  .box-2 {\n    width: 375px;\n  }\n}\n\n/* CSS for Desktop/Laptop (Larger than 1200px wide) */\n@media (max-width: 1200px) {\n  /* Add your CSS styles for desktop/laptop landscape here */\n\n  .request-btn-m {\n    background-color: transparent !important;\n    top: 10% !important;\n    right: 0px !important;\n    box-shadow: none !important;\n  }\n\n  .box-clusters {\n    height: 94px !important;\n  }\n}\n\n@media (min-width: 1200px) and (orientation: portrait) {\n  /* Add your CSS styles for desktop/laptop portrait here */\n\n  .box-clusters {\n    height: 94px !important;\n  }\n}\n\n/* CSS for Tablet Landscape (Breakpoint range: 1024px to 1199px) */\n@media (min-width: 1024px) and (max-width: 1199px) and (orientation: landscape) {\n  .main-menu button {\n    align-items: center !important;\n    color: var(--Black, #000);\n    font-family: \"Helvetica Neue\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    text-transform: uppercase;\n    padding-right: 0rem;\n  }\n  /* Add your CSS styles for tablet landscape here */\n}\n\n@media (min-width: 1024px) and (max-width: 1199px) and (orientation: portrait) {\n  .main-menu button {\n    align-items: center !important;\n    color: var(--Black, #000);\n    font-family: \"Helvetica Neue\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    text-transform: uppercase;\n    padding-right: 0rem;\n  }\n\n  .box-1 {\n    width: 128px !important;\n  }\n\n  .box-2 {\n    /* height: 150px !important; */\n\n    width: 297px !important;\n  }\n\n  /* Add your CSS styles for tablet portrait here */\n}\n@media only screen and (min-width: 800px) and (max-width: 899px) {\n  .about-grid-mobile {\n    margin-top: 0rem !important;\n  }\n\n  .about-grid {\n    display: flex;\n    justify-content: center;\n    align-content: flex-start;\n    flex-wrap: wrap;\n    flex-direction: column !important;\n    align-items: flex-start;\n  }\n  .box-1 {\n    width: 655px !important;\n  }\n\n  .box-2 {\n    width: 643px !important;\n  }\n  .css-mhc70k-MuiGrid-root {\n    flex-direction: column !important;\n\n    /* margin-left: -16px; */\n  }\n\n  .card-section {\n    width: 100% !important;\n    margin-left: 0px !important;\n  }\n  .css-1osj8n2-MuiGrid-root {\n    -webkit-flex-basis: 50%;\n    -ms-flex-preferred-size: 50%;\n    flex-basis: 100% !important;\n    -webkit-box-flex: 0;\n    -webkit-flex-grow: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    max-width: 80% !important;\n  }\n\n  .css-etaaxy-MuiGrid-root {\n    -webkit-flex-basis: 50%;\n    -ms-flex-preferred-size: 50%;\n    flex-basis: 100% !important;\n    -webkit-box-flex: 0;\n    -webkit-flex-grow: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    max-width: 100% !important;\n  }\n\n  .box-clusters {\n    text-align: center !important;\n    border-radius: 8px !important;\n    border: 1px solid rgb(203, 197, 179) !important;\n    height: 100px !important;\n    width: 637px !important;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n\n  img.logo-devloper-ah {\n    width: 100% !important;\n    margin-top: 10rem !important;\n    justify-content: center;\n    flex-wrap: wrap !important;\n    display: inline-flex !important;\n    align-content: space-between;\n    margin-left: 0rem !important;\n    flex-direction: column;\n  }\n  .css-11lxi55-MuiGrid-root {\n    -webkit-flex-basis: 41.666667%;\n    -ms-flex-preferred-size: 41.666667%;\n    flex-basis: 41.666667%;\n    -webkit-box-flex: 0;\n    -webkit-flex-grow: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    max-width: 83.666667% !important;\n  }\n  .css-wn4jt8-MuiGrid-root {\n    flex-direction: column !important;\n  }\n  .css-bwvw8j-MuiGrid-root {\n    flex-basis: 100.666667% !important;\n\n    max-width: 100.666667% !important;\n  }\n\n  .contact-row-ipad {\n    flex-direction: row !important;\n  }\n}\n\n@media only screen and (min-width: 360px) and (max-width: 400px) {\n  .about-grid-mobile {\n    margin-top: -30rem !important;\n  }\n}\n\n@media only screen and (min-width: 600px) and (max-width: 791px) {\n  .about-grid-mobile {\n    margin-top: 0rem !important;\n  }\n}\n\n/* CSS for Tablet Portrait (Breakpoint range: 768px to 1023px) */\n@media (min-width: 768px) and (max-width: 768px) {\n  .about-grid-mobile {\n    margin-top: 0rem !important;\n  }\n  .about-grid {\n    display: flex !important;\n    justify-content: center !important;\n    align-content: flex-start !important;\n    flex-wrap: wrap !important;\n    flex-direction: column !important;\n    align-items: flex-start !important;\n  }\n\n  .box-2 {\n    border: none !important;\n    padding-left: 14px !important;\n  }\n\n  .box-1 {\n    border: none !important;\n  }\n  .location-options {\n    flex-basis: 100.333333% !important;\n    max-width: 100.333333% !important;\n  }\n\n  img.rectangle-10 {\n    max-width: 466px !important;\n  }\n\n  .clustor-container {\n    display: flex;\n    flex-direction: column !important;\n    flex-wrap: nowrap;\n    justify-content: center;\n  }\n  .MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.MuiGrid-grid-sm-6.MuiGrid-grid-md-6.css-etaaxy-MuiGrid-root {\n    flex-basis: 100% !important;\n    -webkit-box-flex: 0;\n    -webkit-flex-grow: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    max-width: 100% !important;\n  }\n\n  .clustor-main-div {\n    display: flex !important;\n    flex-direction: column !important;\n  }\n  .MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.MuiGrid-grid-sm-6.clustor-box-sub.css-1fu1a29-MuiGrid-root {\n    flex-basis: 100% !important;\n    -webkit-box-flex: 0;\n    -webkit-flex-grow: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    max-width: 100% !important;\n  }\n  div#devloper {\n    display: flex !important;\n    flex-direction: column !important;\n  }\n  .css-3qfvb8-MuiGrid-root {\n    -webkit-flex-basis: 66.666667%;\n    -ms-flex-preferred-size: 66.666667%;\n    flex-basis: 66.666667%;\n    -webkit-box-flex: 0;\n    -webkit-flex-grow: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    max-width: 85.666667% !important;\n  }\n\n  .css-bwvw8j-MuiGrid-root {\n    -webkit-flex-basis: 66.666667%;\n    -ms-flex-preferred-size: 66.666667%;\n    flex-basis: 100.666667%;\n    -webkit-box-flex: 0;\n    -webkit-flex-grow: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    max-width: 100.666667%;\n  }\n  .box-clusters {\n    text-align: center !important;\n    border-radius: 8px !important;\n    border: 1px solid rgb(203, 197, 179) !important;\n    height: 100px !important;\n    width: 582px !important;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n\n  /* Add your CSS styles for tablet landscape here */\n}\n\n@media (min-width: 768px) and (max-width: 1023px) and (orientation: portrait) {\n  /* Add your CSS styles for tablet portrait here */\n}\n\n/* CSS for Mobile Landscape (Breakpoint range: 568px to 767px) */\n@media (min-width: 568px) and (max-width: 783px) and (orientation: landscape) {\n  .about-grid-mobile {\n    margin-top: 0rem !important;\n    display: flex;\n    flex-direction: column !important;\n    flex-wrap: wrap;\n  }\n  .about-grid {\n    display: flex !important;\n    justify-content: center;\n    align-content: flex-start;\n    flex-wrap: wrap !important;\n    flex-direction: column !important;\n    align-items: flex-start;\n    /* margin-left: -132px !important; */\n  }\n\n  .box-1 {\n    width: 470px !important;\n  }\n\n  .box-2 {\n    width: 460px !important;\n  }\n\n  .last-box {\n    margin-top: 0rem !important;\n  }\n\n  /* Add your CSS styles for mobile landscape here */\n}\n\n@media (min-width: 568px) and (max-width: 767px) and (orientation: portrait) {\n  .about-grid-mobile {\n    margin-top: 0rem !important;\n    display: flex;\n    flex-direction: column !important;\n    flex-wrap: wrap;\n  }\n  .about-grid {\n    display: flex !important;\n    justify-content: center;\n    align-content: center;\n    flex-wrap: wrap !important;\n    flex-direction: column !important;\n    align-items: flex-start;\n    margin-left: -105px !important;\n  }\n\n  /* Add your CSS styles for mobile portrait here */\n}\n\n/* CSS for Mobile Portrait (Breakpoint range: 0px to 567px) */\n@media (max-width: 567px) and (orientation: landscape) {\n  .about-grid-mobile {\n    margin-top: -9rem !important;\n  }\n\n  .box-1 {\n    width: 420px !important;\n  }\n\n  .box-2 {\n    /* height: 150px !important; */\n\n    width: 408px !important;\n  }\n\n  /* Add your CSS styles for mobile landscape here */\n}\n\n@media (max-width: 567px) and (orientation: portrait) {\n  /* Add your CSS styles for mobile portrait here */\n}\n\n@media only screen and (min-width: 901px) and (max-width: 1199px) {\n  .logo.css-6w6kfw {\n    z-index: 5 !important;\n  }\n  .main-menu-container {\n    /* background-color: #cbc5b3; */\n    /* height: 94px; */\n    /* display: none !important; */\n  }\n  .box-1 {\n    border: none !important;\n    height: 46px !important;\n    align-items: flex-start !important;\n    /* padding: 0px !important; */\n    /* width: auto !important; */\n  }\n\n  .box-2 {\n    border: none !important;\n    height: 46px !important;\n    align-items: flex-start !important;\n    padding: 0px !important;\n    /* width: auto !important; */\n  }\n\n  .last-box {\n    margin-top: 4rem !important;\n    /* display: none; */\n    height: 113px !important;\n  }\n  .about-grid {\n    display: flex;\n    justify-content: flex-start;\n    align-content: flex-start;\n    flex-wrap: wrap;\n    flex-direction: column !important;\n    align-items: flex-start;\n  }\n\n  .css-o4bg9w-MuiGrid-root {\n    -webkit-flex-basis: 66.666667%;\n    -ms-flex-preferred-size: 66.666667%;\n    flex-basis: 100.666667% !important;\n    -webkit-box-flex: 0;\n    -webkit-flex-grow: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    max-width: 100.666667% !important;\n  }\n  .about-des-box {\n    flex-basis: 100.666667% !important;\n\n    max-width: 100.666667% !important;\n  }\n\n  .bg-image-col {\n    flex-basis: 100.333333% !important;\n\n    max-width: 101.333333% !important;\n    padding: 534px !important;\n  }\n\n  .location-options {\n    -webkit-flex-basis: 33.333333%;\n    -ms-flex-preferred-size: 33.333333%;\n    flex-basis: 100.333333% !important;\n    -webkit-box-flex: 0;\n    -webkit-flex-grow: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    max-width: 101.333333% !important;\n  }\n  .css-etaaxy-MuiGrid-root {\n    flex-basis: 100% !important;\n\n    max-width: 104% !important;\n  }\n\n  .css-1osj8n2-MuiGrid-root {\n    -webkit-flex-basis: 50%;\n    -ms-flex-preferred-size: 50%;\n    flex-basis: 100% !important;\n    -webkit-box-flex: 0;\n    -webkit-flex-grow: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    max-width: 100% !important;\n  }\n\n  .partners-container {\n    display: block !important;\n  }\n\n  .aminities-container {\n    display: flex !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n    margin-top: 30px !important;\n    margin-bottom: 30px !important;\n    border-radius: 8px !important;\n    flex-wrap: wrap !important;\n  }\n\n  div#devloper {\n    display: flex !important;\n    flex-direction: column !important;\n  }\n\n  img.logo-devloper-ah {\n    width: 60% !important;\n    margin-top: 0rem !important;\n    justify-content: center !important;\n    flex-wrap: wrap !important;\n    display: inline-flex !important;\n    align-content: center !important;\n    margin-left: 0rem !important;\n  }\n\n  .css-1qokjtz {\n    font-family: sectionTitleFont;\n    position: absolute;\n    top: 30%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    -moz-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    text-align: center;\n    color: white;\n    font-size: 30px;\n    font-weight: bold;\n    z-index: 999999 !important;\n  }\n  .clustor-container {\n    flex-direction: column !important;\n  }\n}\n\n.css-1qokjtz {\n  /* z-index: 999999 !important; */\n}\n\n.css-1lhfysi {\n  /* z-index: 999999 !important; */\n}\n\n.css-fv3sos button {\n  /* z-index: 999999 !important; */\n}\n\n@media (max-width: 1200px) {\n  .box-1 {\n    border: none !important;\n    height: 60px !important;\n  }\n\n  .box-2 {\n    border: none !important;\n    height: 60px !important;\n  }\n  .css-etaaxy-MuiGrid-root {\n    max-width: 100%;\n    padding-right: 0px !important;\n  }\n\n  /* .css-1osj8n2-MuiGrid-root {\n    flex-basis: 90% !important;\n\n    max-width: 90% !important;\n  }\n\n  .box-clusters {\n    text-align: center !important;\n    border-radius: 8px !important;\n    border: 1px solid rgb(203, 197, 179) !important;\n    height: 100px !important;\n    width: 100% !important;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  } */\n  p.MuiTypography-root.MuiTypography-body1.location-sub.css-naxtqj-MuiTypography-root {\n    padding-left: 13px;\n  }\n\n  .bg-image-col {\n    max-width: 106.333333% !important;\n    padding-top: 496px !important;\n    margin: auto !important;\n    width: 100% !important;\n    /* height: 100% !important; */\n    margin-top: 2rem !important;\n    margin-left: 1rem !important;\n  }\n\n  img.logo-devloper-ah {\n    align-items: center !important;\n  }\n}\n\n.request-btn {\n  display: none !important;\n}\n\n/* menu css start here */\n\n.request-btn-m {\n  background-color: transparent !important;\n}\n.menu-box-right-col {\n}\n\n.MuiPaper-root.MuiPaper-elevation.MuiPaper-elevation16.MuiDrawer-paper.MuiDrawer-paperAnchorRight.css-1160xiw-MuiPaper-root-MuiDrawer-paper {\n  width: 330px;\n  z-index: 100049;\n}\n\nli.nav-link-btn {\n  color: var(--Black, #000);\n  font-family: \"Helvetica Neue\", sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-transform: uppercase;\n\n  list-style: none;\n  text-decoration: none;\n}\n\n.nav-link-btn a {\n  color: black !important;\n  text-decoration: none !important;\n}\n\n.ul.menu-container {\n  text-decoration: none !important;\n}\n\n.inner-header {\n}\n.header-content {\n}\n\nul.menu-header {\n  display: flex;\n  justify-content: space-between;\n  list-style: none;\n  padding: 20px;\n  color: var(--Black, #000);\n  font-family: \"Playfair Display\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-transform: uppercase;\n}\n.request-btn-m {\n  z-index: 9999px !important;\n}\n\ndiv#main_menu_container-inner-header {\n  position: fixed;\n  z-index: 99;\n  top: 0;\n}\n\n.request-btn-m {\n  background-color: transparent !important;\n  z-index: 8;\n}\n\n.contact-btn {\n}\n\nul.contact-menu {\n  padding: 12px;\n}\n\nli.contact-list {\n  border: 1px solid var(--Secondary, #cbc5b3);\n  padding: 20px 10px;\n  list-style: none;\n  text-decoration: none;\n}\n\nli.contact-list {\n  border: 1px solid var(--Secondary, #cbc5b3);\n  padding: 20px 10px;\n  list-style: none;\n  text-decoration: none;\n  color: var(--Primary, #313b2f);\n  font-family: \"Helvetica Neue\", sans-serif;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-transform: uppercase;\n  text-decoration: none;\n  text-align: center;\n}\n\nli.contact-list a {\n  text-decoration: none;\n  color: var(--Primary, #313b2f);\n}\n\n.contact-menu {\n  width: 96%;\n  position: absolute;\n  bottom: 0rem;\n}\n.nav-link-btn {\n  padding: 20px 32px;\n  /* margin-bottom: 1rem; */\n}\n\nli.nav-link-btn:hover {\n  background-color: #cbc5b3;\n}\n\nli.nav-link-btn {\n  width: 85%;\n  padding-left: 10px;\n  margin-top: 1rem;\n}\n\nul.menu-container {\n  padding: 0px 20px;\n}\n.contact-list:hover {\n  background-color: #cbc5b3;\n}\n\n[data-aos][data-aos][data-aos-duration=\"400\"],\nbody[data-aos-duration=\"400\"] [data-aos] {\n  transition-duration: 3.4s !important;\n}\n\n/* .header-content {\n  position: relative;\n  top: 48px;\n} */\n\nimg.logo.css-yb1sgc {\n  width: 100px !important;\n  height: auto !important;\n  margin-top: 70px;\n}\n\n.request-btn-m {\n  margin-top: 35px !important;\n}\n\n.MuiPaper-root.MuiPaper-elevation.MuiPaper-elevation16.MuiDrawer-paper.MuiDrawer-paperAnchorRight.css-1160xiw-MuiPaper-root-MuiDrawer-paper {\n  width: 330px;\n  z-index: 100049;\n}\n\n/* menu arrow css start here */\n\nimg.menu-arrow {\n  float: inline-end;\n  border: 1px solid;\n  margin-top: 0px;\n  margin-right: -22px;\n  padding: 5px 2px;\n  width: 20px;\n}\n\n/* padding all section css start */\n\n@media only screen and (min-width: 1500px) and (max-width: 1920px) {\n  .partners-container .partners-des {\n    padding-left: 20px !important;\n  }\n  .Feature-container-main {\n    padding-left: 120px !important;\n    padding-right: 120px !important;\n  }\n\n  .experience-container-main {\n    flex-basis: 100.666667% !important;\n\n    max-width: 100.666667% !important;\n  }\n\n  .features-container {\n    width: 45vw !important;\n  }\n  .amenities-main-section {\n    padding-left: 120px !important;\n    padding-right: 120px !important;\n  }\n\n  .request-btn-m {\n    background-color: transparent !important;\n    top: 14% !important;\n    right: 65px !important;\n    box-shadow: none !important;\n  }\n\n  .features-container {\n    width: 84vw !important;\n  }\n  .about-container {\n    padding-left: 120px !important;\n    padding-right: 120px !important;\n  }\n  .location-main-section {\n    padding-left: 120px !important;\n    padding-right: 120px !important;\n  }\n\n  .clustor-container {\n    padding-left: 120px !important;\n    padding-right: 120px !important;\n  }\n  .devloper-container {\n    padding-left: 120px !important;\n    padding-right: 120px !important;\n  }\n  .partners-container-main {\n    padding-left: 120px !important;\n    padding-right: 120px !important;\n  }\n  .contact-container-main-section {\n    padding-left: 120px !important;\n    padding-right: 120px !important;\n  }\n\n  .about-sub-box {\n    color: var(--Black, #000);\n    font-family: \"Helvetica Neue\", sans-serif;\n    font-size: 16px !important;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1500px) {\n  .partners-container .partners-des {\n    padding-left: 20px !important;\n  }\n  .request-btn-m {\n    background-color: transparent !important;\n    top: 11% !important;\n    right: 5% !important;\n    box-shadow: none !important;\n  }\n\n  .footer-menu li a {\n    font-size: 16px !important;\n  }\n\n  .social-links-item a {\n    font-size: 16px !important;\n\n    text-decoration: none !important;\n  }\n\n  .logo.css-6w6kfw {\n    top: 10% !important;\n    left: 10% !important;\n  }\n  .about-container {\n    padding-left: 120px !important;\n    padding-right: 120px !important;\n  }\n  .location-main-section {\n    padding-left: 120px !important;\n    padding-right: 120px !important;\n  }\n\n  .clustor-container {\n    padding-left: 120px !important;\n    padding-right: 120px !important;\n  }\n  .devloper-container {\n    padding-left: 120px !important;\n    padding-right: 120px !important;\n  }\n  .partners-container-main {\n    padding-left: 120px !important;\n    padding-right: 120px !important;\n  }\n  .contact-container-main-section {\n    padding-left: 120px !important;\n    padding-right: 120px !important;\n  }\n}\n\n@media only screen and (min-width: 200px) and (max-width: 500px) {\n  .about-container {\n    padding-left: 16px !important;\n    padding-right: 16px !important;\n  }\n\n  .MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.MuiGrid-grid-sm-3.MuiGrid-grid-xl-5.css-1q9c3ht-MuiGrid-root {\n    padding-left: 0px !important;\n  }\n\n  .about-grid-mobile-boxes {\n    padding-left: 0px !important;\n  }\n\n  .css-mhc70k-MuiGrid-root > .MuiGrid-item {\n    padding-left: 0px !important;\n  }\n  .bg-image-col {\n    padding-left: 16px !important;\n    padding-right: 16px !important;\n  }\n\n  .clustor-main-div {\n    padding-left: 16px !important;\n    padding-right: 16px !important;\n  }\n  .location-main-section {\n    padding-left: 16px !important;\n    padding-right: 16px !important;\n  }\n\n  .clustor-container {\n    padding-left: 16px !important;\n    padding-right: 16px !important;\n  }\n  .devloper-container {\n    padding-left: 16px !important;\n    padding-right: 16px !important;\n  }\n  .partners-container-main {\n    padding-left: 16px !important;\n    padding-right: 16px !important;\n  }\n  .contact-container-main-section {\n    padding-left: 16px !important;\n    padding-right: 16px !important;\n  }\n\n  .clustor-boxes-section-main {\n  }\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1500px) {\n  .experience-container-main {\n    flex-basis: 100.666667% !important;\n\n    max-width: 90.666667% !important;\n  }\n\n  .boxs-border-cards {\n    gap: 67px !important;\n  }\n\n  .discription-pera {\n    font-size: 16px !important;\n  }\n  .discription-pera-main {\n    font-size: 16px !important;\n  }\n\n  .about {\n    padding-top: 10px !important;\n    padding-bottom: 0px !important;\n  }\n\n  .icon-list-title {\n    font-size: 16px !important;\n  }\n\n  .icon-list-heading {\n    font-size: 20px !important;\n  }\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1280px) {\n  ul.footer-menu {\n    display: flex;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    gap: 1rem !important;\n    padding: 0px;\n    list-style: none;\n  }\n}\na.text-black-nav {\n  text-decoration: none;\n}\n/* end */\n\n/* end */\n\n/* end css */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
